/*
 * HORANDO – Uhr live am eigenen Handgelenk (Kamera)
 * Wird erst geladen, wenn im Handgelenk-Fenster auf "Live mit Kamera" getippt wird
 * (assets/horando-wrist-tryon.js). Handerkennung: MediaPipe Hand Landmarker im Browser,
 * keine Bilder verlassen das Gerät.
 *
 * Massstab: Breite des Unterarms im Bild (Hautfarbe bis zur Kante), ersatzweise aus der Hand.
 * 3D: Gehaeuse und Band (aus dem Produktfoto) um ein elliptisches Handgelenk, three.js.
 * Das Uhrenbild ist das freigestellte Bild aus dem Handgelenk-Fenster (HorandoTryOn.analyse).
 */
(function () {
  'use strict';
  if (window.HorandoWristAR) return;

  var MP = 'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.14';
  var THREE_URL = 'https://cdn.jsdelivr.net/npm/three@0.160.0/build/three.module.min.js';
  var MODEL = 'https://storage.googleapis.com/mediapipe-models/hand_landmarker/hand_landmarker/float16/1/hand_landmarker.task';
  // Segmentierung (Haut/Kleidung/Hintergrund): findet den Arm auch ohne sichtbare Hand
  var SEG_MODEL = 'https://storage.googleapis.com/mediapipe-models/image_segmenter/selfie_multiclass_256x256/float32/1/selfie_multiclass_256x256.tflite';

  var I18N = {
    de: { btn: 'Live mit Kamera', btnSub: 'Die Uhr direkt am eigenen Handgelenk sehen', title: 'Live am Handgelenk', loading: 'Kamera wird gestartet …', point: 'Halten Sie Ihr Handgelenk mit dem Handrücken nach oben unter die Uhr – die Größe wird kurz an Ihr Handgelenk angepasst.', back: 'Bitte den Handrücken zur Kamera drehen.', note: 'Größe aus der Breite Ihres Handgelenks geschätzt (ca. ± 10 %).', denied: 'Kein Kamerazugriff. Bitte erlauben Sie die Kamera in den Browser-Einstellungen.', fail: 'Die Kamera-Ansicht ist auf diesem Gerät leider nicht verfügbar.', flip: 'Kamera wechseln', close: 'Schließen' },
    en: { btn: 'Live with camera', btnSub: 'See the watch on your own wrist', title: 'Live on your wrist', loading: 'Starting camera …', point: 'Hold your wrist under the watch, back of the hand up – the size is briefly adjusted to your wrist.', back: 'Please turn the back of your hand towards the camera.', note: 'Size estimated from the width of your wrist (approx. ± 10 %).', denied: 'No camera access. Please allow the camera in your browser settings.', fail: 'The camera view is not available on this device.', flip: 'Switch camera', close: 'Close' },
    fr: { btn: 'En direct avec la caméra', btnSub: 'Voir la montre sur votre propre poignet', title: 'En direct au poignet', loading: 'Démarrage de la caméra …', point: 'Placez votre poignet sous la montre, dos de la main vers le haut – la taille s’ajuste brièvement à votre poignet.', back: 'Veuillez tourner le dos de la main vers la caméra.', note: 'Taille estimée à partir de la largeur de votre poignet (env. ± 10 %).', denied: 'Pas d’accès à la caméra. Veuillez l’autoriser dans les réglages du navigateur.', fail: 'L’affichage caméra n’est pas disponible sur cet appareil.', flip: 'Changer de caméra', close: 'Fermer' },
    it: { btn: 'Dal vivo con la fotocamera', btnSub: 'Guarda l’orologio sul tuo polso', title: 'Dal vivo al polso', loading: 'Avvio della fotocamera …', point: 'Tieni il polso sotto l’orologio con il dorso della mano verso l’alto: la dimensione si adatta brevemente al tuo polso.', back: 'Gira il dorso della mano verso la fotocamera.', note: 'Dimensione stimata dalla larghezza del polso (circa ± 10 %).', denied: 'Nessun accesso alla fotocamera. Consentila nelle impostazioni del browser.', fail: 'La vista con fotocamera non è disponibile su questo dispositivo.', flip: 'Cambia fotocamera', close: 'Chiudi' },
    es: { btn: 'En vivo con la cámara', btnSub: 'Vea el reloj en su propia muñeca', title: 'En vivo en la muñeca', loading: 'Iniciando la cámara …', point: 'Coloque la muñeca bajo el reloj con el dorso de la mano hacia arriba: el tamaño se ajusta brevemente a su muñeca.', back: 'Gire el dorso de la mano hacia la cámara.', note: 'Tamaño estimado a partir del ancho de su muñeca (aprox. ± 10 %).', denied: 'Sin acceso a la cámara. Permítala en los ajustes del navegador.', fail: 'La vista con cámara no está disponible en este dispositivo.', flip: 'Cambiar cámara', close: 'Cerrar' },
    pt: { btn: 'Ao vivo com a câmara', btnSub: 'Veja o relógio no seu próprio pulso', title: 'Ao vivo no pulso', loading: 'A iniciar a câmara …', point: 'Coloque o pulso sob o relógio com as costas da mão para cima – o tamanho ajusta-se brevemente ao seu pulso.', back: 'Vire as costas da mão para a câmara.', note: 'Tamanho estimado a partir da largura do seu pulso (aprox. ± 10 %).', denied: 'Sem acesso à câmara. Permita-a nas definições do navegador.', fail: 'A vista com câmara não está disponível neste dispositivo.', flip: 'Mudar de câmara', close: 'Fechar' },
    sv: { btn: 'Live med kameran', btnSub: 'Se klockan på din egen handled', title: 'Live på handleden', loading: 'Kameran startar …', point: 'Håll handleden under klockan med handryggen uppåt – storleken anpassas kort till din handled.', back: 'Vänd handryggen mot kameran.', note: 'Storleken uppskattas utifrån handledens bredd (ca ± 10 %).', denied: 'Ingen kameraåtkomst. Tillåt kameran i webbläsarens inställningar.', fail: 'Kameravyn är inte tillgänglig på den här enheten.', flip: 'Byt kamera', close: 'Stäng' },
    hu: { btn: 'Élőben a kamerával', btnSub: 'Nézze meg az órát a saját csuklóján', title: 'Élőben a csuklón', loading: 'A kamera indul …', point: 'Tartsa a csuklóját az óra alá, kézfejjel felfelé – a méret rövid időn belül a csuklójához igazodik.', back: 'Kérjük, fordítsa a kézfejét a kamera felé.', note: 'A méret a csuklója szélessége alapján becsült (kb. ± 10 %).', denied: 'Nincs hozzáférés a kamerához. Engedélyezze a böngésző beállításaiban.', fail: 'A kamerás nézet ezen az eszközön nem érhető el.', flip: 'Kameraváltás', close: 'Bezárás' },
    ru: { btn: 'Вживую с камерой', btnSub: 'Посмотрите часы на своём запястье', title: 'Вживую на запястье', loading: 'Запуск камеры …', point: 'Держите запястье под часами тыльной стороной вверх – размер ненадолго подстроится под ваше запястье.', back: 'Пожалуйста, поверните тыльную сторону ладони к камере.', note: 'Размер оценён по ширине вашего запястья (около ± 10 %).', denied: 'Нет доступа к камере. Разрешите камеру в настройках браузера.', fail: 'Режим камеры недоступен на этом устройстве.', flip: 'Сменить камеру', close: 'Закрыть' },
    uk: { btn: 'Наживо з камерою', btnSub: 'Подивіться годинник на власному зап’ясті', title: 'Наживо на зап’ясті', loading: 'Запуск камери …', point: 'Тримайте зап’ястя під годинником тильною стороною догори – розмір ненадовго підлаштується під ваше зап’ястя.', back: 'Будь ласка, поверніть тильну сторону долоні до камери.', note: 'Розмір оцінено за шириною вашого зап’ястя (приблизно ± 10 %).', denied: 'Немає доступу до камери. Дозвольте камеру в налаштуваннях браузера.', fail: 'Режим камери недоступний на цьому пристрої.', flip: 'Змінити камеру', close: 'Закрити' }
  };
  function lang() { var l = (document.documentElement.lang || 'de').toLowerCase().slice(0, 2); return I18N[l] ? l : 'de'; }
  var T = I18N[lang()];

  // Durchschnittsmasse in mm (Fingergrundgelenke 5-17, Handgelenk-Mittelfingergrundgelenk 0-9)
  var BODY = {
    m: { palm: 63, len: 100, wrist: 60, offset: 26 },
    f: { palm: 57, len: 90, wrist: 53, offset: 22 }
  };

  // ES-Module laden. Bewusst KEIN import() im Quelltext: Shopify minifiziert Theme-JS und macht
  // aus import() ein require() – das gibt es im Browser nicht ("Can't find variable: require").
  // Deshalb wird ein <script type="module"> eingefuegt, das importiert und zurueckmeldet.
  var esmN = 0;
  function esm(url) {
    return new Promise(function (res, rej) {
      var k = '__hwarEsm' + (++esmN) + '_' + Date.now();
      var done = false;
      window[k] = function (err, mod) { done = true; try { delete window[k]; } catch (x) { window[k] = undefined; } if (err) rej(err); else res(mod); };
      var sc = document.createElement('script'); sc.type = 'module';
      sc.textContent = 'imp' + 'ort(' + JSON.stringify(url) + ').then(function(m){window["' + k + '"](null,m)},function(e){window["' + k + '"](e||new Error("esm"))});';
      sc.onerror = function () { if (!done) window[k] && window[k](new Error('esm script')); };
      document.head.appendChild(sc);
      setTimeout(function () { if (!done && window[k]) window[k](new Error('esm timeout')); }, 45000);
    });
  }

  var landmarkerP = null, procInfo = '';
  // Der MediaPipe-Lader (Emscripten) haelt sich fuer Node.js, sobald irgendein Skript der Seite ein
  // globales "process" anlegt (auf iOS der Fall) – und ruft dann require() auf. Deshalb laden wir den
  // Lader selbst, schalten die Node-Erkennung im Text ab und geben ihn als Blob-URL weiter.
  function patchedFileset(fs) {
    return fetch(fs.wasmLoaderPath).then(function (r) {
      if (!r.ok) throw new Error('loader ' + r.status);
      return r.text();
    }).then(function (src) {
      var fixed = src.replace(/var ENVIRONMENT_IS_NODE\s*=/, 'var ENVIRONMENT_IS_NODE=false&&');
      if (fixed === src) procInfo += ' nopatch';
      var url = URL.createObjectURL(new Blob([fixed], { type: 'text/javascript' }));
      return { wasmLoaderPath: url, wasmBinaryPath: fs.wasmBinaryPath };
    }).catch(function (e) { procInfo += ' pf:' + (e && e.message); return fs; });
  }
  function loadLandmarker() {
    if (landmarkerP) return landmarkerP;
    try { procInfo = 'tp:' + (typeof process); } catch (x) {}
    // MediaPipe uebernimmt ein globales window.Module (Emscripten-Konvention), wenn eines existiert.
    // Fremde Skripte im Shop legen auf manchen Geraeten eines an -> fuer die Ladezeit ausblenden.
    var hidden = {};
    ['Module', 'ModuleFactory'].forEach(function (k) {
      try {
        if (typeof window[k] !== 'undefined') {
          hidden[k] = window[k]; procInfo += ' ' + k;
          try { window[k] = undefined; } catch (x) {}
          if (typeof window[k] !== 'undefined') { try { Object.defineProperty(window, k, { value: undefined, writable: true, configurable: true }); } catch (x) { procInfo += '!'; } }
        }
      } catch (x) {}
    });
    var restore = function () { Object.keys(hidden).forEach(function (k) { try { window[k] = hidden[k]; } catch (x) {} }); hidden = {}; };
    landmarkerP = esm(MP + '/vision_bundle.mjs').then(function (v) {
      return v.FilesetResolver.forVisionTasks(MP + '/wasm').then(patchedFileset).then(function (fs) {
        visionMod = v; filesetObj = fs;
        var make = function (delegate) {
          return v.HandLandmarker.createFromOptions(fs, {
            baseOptions: { modelAssetPath: MODEL, delegate: delegate },
            runningMode: 'VIDEO', numHands: 1,
            minHandDetectionConfidence: 0.5, minHandPresenceConfidence: 0.5, minTrackingConfidence: 0.5
          });
        };
        // iOS/WebKit: GPU-Delegate ist dort unzuverlaessig -> direkt CPU
        var ios = /iPhone|iPad|iPod/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        if (ios) return make('CPU');
        return make('GPU').catch(function () { return make('CPU'); });
      });
    }).then(function (r) { restore(); return r; }, function (e) { restore(); throw e; });
    landmarkerP.catch(function () { landmarkerP = null; });
    return landmarkerP;
  }

  var visionMod = null, filesetObj = null, segmenterP = null, segm = null;
  function loadSegmenter() {
    if (segmenterP || !visionMod) return segmenterP;
    var hidden = {};
    ['Module', 'ModuleFactory'].forEach(function (k) { try { if (typeof window[k] !== 'undefined') { hidden[k] = window[k]; window[k] = undefined; } } catch (x) {} });
    var restore = function () { Object.keys(hidden).forEach(function (k) { try { window[k] = hidden[k]; } catch (x) {} }); };
    var ios = /iPhone|iPad|iPod/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var make = function (dl) {
      return visionMod.ImageSegmenter.createFromOptions(filesetObj, { baseOptions: { modelAssetPath: SEG_MODEL, delegate: dl }, runningMode: 'VIDEO', outputCategoryMask: true, outputConfidenceMasks: false });
    };
    segmenterP = (ios ? make('CPU') : make('GPU').catch(function () { return make('CPU'); }))
      .then(function (r) { restore(); segm = r; return r; }, function (e) { restore(); segmenterP = null; throw e; });
    segmenterP.catch(function () {});
    return segmenterP;
  }


  /* ---------- Erkennung im Hintergrund (Web Worker) ----------
     Hand- und Armerkennung laufen in einem eigenen Thread. Das Kamerabild und die Uhr werden dadurch
     fluessig mit voller Bildrate gezeichnet, auch wenn eine Erkennung einmal laenger dauert. */
  var WORKER_SRC = "var exports = {}, module = { exports: exports };\nvar V = null, hand = null, seg = null, busy = false;\nfunction make(cls, opts, ios) {\n  var f = function (dl) { opts.baseOptions.delegate = dl; return cls.createFromOptions(V.fs, opts); };\n  return ios ? f('CPU') : f('GPU').catch(function () { return f('CPU'); });\n}\nself.onmessage = function (ev) {\n  var d = ev.data;\n  if (d.type === 'init') {\n    try {\n      importScripts(d.mp + '/vision_bundle.cjs');\n      var api = module.exports && module.exports.HandLandmarker ? module.exports : exports;\n      api.FilesetResolver.forVisionTasks(d.mp + '/wasm').then(function (fs) {\n        V = { api: api, fs: fs };\n        return make(api.HandLandmarker, { baseOptions: { modelAssetPath: d.hand }, runningMode: 'VIDEO', numHands: 1, minHandDetectionConfidence: 0.5, minHandPresenceConfidence: 0.5, minTrackingConfidence: 0.5 }, d.ios);\n      }).then(function (h) {\n        hand = h; self.postMessage({ type: 'ready' });\n        return make(V.api.ImageSegmenter, { baseOptions: { modelAssetPath: d.seg }, runningMode: 'VIDEO', outputCategoryMask: true, outputConfidenceMasks: false }, d.ios);\n      }).then(function (s) { seg = s; self.postMessage({ type: 'segready' }); })\n        .catch(function (e) { self.postMessage({ type: hand ? 'segfail' : 'fail', msg: String(e && e.message || e) }); });\n    } catch (e) { self.postMessage({ type: 'fail', msg: String(e && e.message || e) }); }\n    return;\n  }\n  if (d.type === 'frame') {\n    var out = { type: 'result', id: d.id, t: d.t };\n    try {\n      if (hand && d.hand) {\n        var r = hand.detectForVideo(d.bmp, d.t);\n        if (r && r.landmarks && r.landmarks.length) {\n          out.lm = r.landmarks[0].map(function (p) { return [p.x, p.y]; });\n          out.wl = r.worldLandmarks && r.worldLandmarks[0] ? r.worldLandmarks[0].map(function (p) { return [p.x, p.y, p.z]; }) : null;\n          out.label = r.handednesses && r.handednesses[0] && r.handednesses[0][0] ? r.handednesses[0][0].categoryName : 'Right';\n        }\n      }\n      if (seg && d.seg) {\n        var s = seg.segmentForVideo(d.bmp, d.t + 0.5), m = s && s.categoryMask;\n        if (m) { var a = new Uint8Array(m.getAsUint8Array()); out.mask = { a: a, w: m.width, h: m.height }; }\n        try { if (s.close) s.close(); else if (m && m.close) m.close(); } catch (e) {}\n      }\n    } catch (e) { out.err = String(e && e.message || e); }\n    try { d.bmp.close(); } catch (e) {}\n    if (out.mask) self.postMessage(out, [out.mask.a.buffer]); else self.postMessage(out);\n  }\n};\n";
  var wk = null, wkBusy = false, wkSegReady = false, wkId = 0, wkGeom = {}, lastHandT = 0;
  function startWorker() {
    return new Promise(function (res, rej) {
      var w;
      try { w = new Worker(URL.createObjectURL(new Blob([WORKER_SRC], { type: 'text/javascript' }))); } catch (e) { rej(e); return; }
      var to = setTimeout(function () { try { w.terminate(); } catch (e) {} rej(new Error('worker timeout')); }, 60000);
      w.onmessage = function (ev) {
        var d = ev.data;
        if (d.type === 'ready') { clearTimeout(to); wk = w; res(w); }
        else if (d.type === 'fail') { clearTimeout(to); try { w.terminate(); } catch (e) {} rej(new Error(d.msg)); }
        else if (d.type === 'segready') wkSegReady = true;
        else if (d.type === 'result') onWorkerResult(d);
      };
      w.onerror = function (e) { clearTimeout(to); rej(new Error((e && e.message) || 'worker error')); };
      var ios = /iPhone|iPad|iPod/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      w.postMessage({ type: 'init', mp: MP, hand: MODEL, seg: SEG_MODEL, ios: ios });
    });
  }
  function sendFrame(now, g) {
    var hr = now - lastHandT < 600;
    var wantSeg = wkSegReady && ((!sm || !raw) ? now - lastSegT > 250 : (!hr && now - lastSegT > 900));
    if (wantSeg) lastSegT = now;
    var id = ++wkId; wkGeom[id] = g; wkBusy = true;
    var p;
    try { p = createImageBitmap(detCv); } catch (e) { wkBusy = false; return; }
    p.then(function (bmp) {
      if (!wk) return;
      wk.postMessage({ type: 'frame', id: id, t: now, bmp: bmp, hand: true, seg: wantSeg }, [bmp]);
    }).catch(function () { wkBusy = false; delete wkGeom[id]; });
  }
  function onWorkerResult(d) {
    wkBusy = false;
    var g = wkGeom[d.id]; delete wkGeom[d.id];
    if (!g || !running) return;
    var now = performance.now();
    if (d.lm) {
      var L = d.lm.map(function (p) { var x = g.dx + p[0] * g.dw, y = g.dy + p[1] * g.dh; return { x: g.mirror ? g.W - x : x, y: y }; });
      var rl = d.lm, cross = (rl[5][0] - rl[0][0]) * (rl[17][1] - rl[0][1]) - (rl[5][1] - rl[0][1]) * (rl[17][0] - rl[0][0]);
      var backFacing = d.label === 'Right' ? cross > 0 : cross < 0;
      var WL = d.wl ? d.wl.map(function (p) { return { x: p[0], y: p[1], z: p[2] }; }) : null;
      if (smallData) { maskReset(); handUpdate(L, backFacing, WL, g.mirror, now); }
      lastSeen = now; lastHandT = now;
    }
    if (d.mask) {
      var S = { a: d.mask.a, w: d.mask.w, h: d.mask.h, dx: g.dx, dy: g.dy, dw: g.dw, dh: g.dh, mirror: g.mirror };
      if (!sm || !raw) { if (smallData && segAcquire(S, g.W, g.H, now)) lastSeen = now; }
      else if (!d.lm) { if (!segVerify(S, g.W)) { if (++segBad >= 2) { sm = null; raw = null; F = null; lastArmT = 0; segBad = 0; } } else segBad = 0; }
    }
  }

  var threeP = null;
  function loadThree() {
    if (!threeP) threeP = esm(THREE_URL).catch(function () { threeP = null; return null; });
    return threeP;
  }

  function css() {
    if (document.getElementById('hwar-css')) return;
    var s = document.createElement('style'); s.id = 'hwar-css';
    s.textContent =
      '.hwar{position:fixed;left:0;top:0;right:0;bottom:0;height:100vh;height:100dvh;z-index:2147483600;background:#000;color:#fff;font-family:"IBM Plex Sans",sans-serif;overflow:hidden;touch-action:none}' +
      '.hwar canvas{position:absolute;left:0;top:0;width:100%;height:100%;display:block}.hwar canvas.hwar-gl{pointer-events:none}' +
      '.hwar video{position:absolute;left:0;top:0;width:100%;height:100%;object-fit:cover;pointer-events:none}.hwar video.mir{transform:scaleX(-1)}' +
      '.hwar-top{position:absolute;left:0;right:0;top:0;display:flex;align-items:center;justify-content:space-between;padding:12px 14px;padding-top:max(12px,env(safe-area-inset-top));background:linear-gradient(rgba(0,0,0,.55),rgba(0,0,0,0));z-index:2}' +
      '.hwar-top h3{margin:0;font-family:"DM Sans",sans-serif;font-size:13px;font-weight:500;letter-spacing:.12em;text-transform:uppercase;color:#fff}.hwar-top small{display:block;font-family:"IBM Plex Sans",sans-serif;font-size:12px;letter-spacing:0;text-transform:none;opacity:.8;margin-top:2px}' +
      '.hwar-x{background:none;border:0;color:#fff;font-size:32px;line-height:1;padding:4px 8px;cursor:pointer;min-height:0}' +
      '.hwar-bot{position:absolute;left:0;right:0;bottom:0;padding:14px 16px;padding-bottom:max(16px,env(safe-area-inset-bottom));background:linear-gradient(rgba(0,0,0,0),rgba(0,0,0,.6));z-index:2;display:flex;align-items:flex-end;justify-content:space-between;gap:12px}' +
      '.hwar-msg{font-size:14px;line-height:1.45;max-width:520px}.hwar-msg small{display:block;opacity:.75;font-size:12px;margin-top:4px}' +
      '.hwar-flip{flex:0 0 auto;width:46px;height:46px;min-height:0;border-radius:50%;border:1px solid rgba(255,255,255,.7);background:rgba(0,0,0,.25);color:#fff;display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0}.hwar-flip svg{width:22px;height:22px}' +
      '.hwar-center{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);text-align:center;font-size:15px;padding:0 24px;width:100%;box-sizing:border-box;z-index:1}';
    document.head.appendChild(s);
  }

  var tapPt = null, acqN = 0, detN = 0, D = null, lockPpm = null, lockBuf = [], lockOff = 0, lockLastT = -1, root, video, cv, ctx, off, offCtx, smallCv, smallCtx, smallData, detCv, detCtx, F = null, ratioBuf = [], lastArmT = 0, SK = 4, watchImg, stream, raf, opts, body, facing, lm, lastVideoTime = -1, lastSeen = 0, sm = null, running = false;

  /* One-Euro-Filter: ruhig bei stillem Arm, wenig Verzoegerung bei Bewegung */
  function OE(minCut, beta) { this.mc = minCut; this.b = beta; this.x = null; this.d = 0; this.t = 0; }
  OE.prototype.f = function (x, t) {
    if (this.x === null) { this.x = x; this.t = t; return x; }
    var dt = Math.max(0.001, (t - this.t) / 1000); this.t = t;
    var al = function (c) { var r = 1 / (2 * Math.PI * c); return 1 / (1 + r / dt); };
    var dx = (x - this.x) / dt; this.d += al(1) * (dx - this.d);
    this.x += al(this.mc + this.b * Math.abs(this.d)) * (x - this.x);
    return this.x;
  };
  function newFilters() {
    return { cx: new OE(0.45, 0.003), cy: new OE(0.45, 0.003), ux: new OE(0.7, 0.2), uy: new OE(0.7, 0.2),
      ppm: new OE(0.3, 0.005), side: new OE(2, 0), dx: new OE(0.6, 0.2), dy: new OE(0.6, 0.2), dz: new OE(0.6, 0.2), back: new OE(1.5, 0) };
  }
  function median(a) { var b = a.slice().sort(function (p, q) { return p - q; }); return b[Math.floor(b.length / 2)]; }

  function msg(main, small) {
    var m = root && root.querySelector('.hwar-msg'); if (!m) return;
    m.innerHTML = (main || '') + (small ? '<small>' + small + '</small>' : '');
  }
  function center(text) { var c = root && root.querySelector('.hwar-center'); if (c) c.textContent = text || ''; }

  function open(o) {
    opts = o; body = o.female ? BODY.f : BODY.m; flatC = null;
    facing = /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent) ? 'environment' : 'user';
    css();
    root = document.createElement('div'); root.className = 'hwar'; root.setAttribute('role', 'dialog'); root.setAttribute('aria-modal', 'true');
    root.innerHTML =
      '<video playsinline muted autoplay></video><canvas></canvas>' +
      '<div class="hwar-center">' + T.loading + '</div>' +
      '<div class="hwar-top"><h3>' + T.title + '<small>' + esc(o.title || '') + '</small></h3><button class="hwar-x" aria-label="' + T.close + '">&times;</button></div>' +
      '<div class="hwar-bot"><div class="hwar-msg"></div>' +
      '<button class="hwar-flip" aria-label="' + T.flip + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 8h3l2-3h6l2 3h3v11H4z"/><path d="M9.5 13.5a2.5 2.5 0 0 0 4.9.7M14.5 12.5a2.5 2.5 0 0 0-4.9-.7"/><path d="M14.6 14.4l-.2 1.4-1.3-.6M9.4 10.6l.2-1.4 1.3.6"/></svg></button></div>';
    document.body.appendChild(root);
    video = root.querySelector('video'); cv = root.querySelector('canvas'); ctx = cv.getContext('2d');
    off = document.createElement('canvas'); offCtx = off.getContext('2d');
    smallCv = document.createElement('canvas'); smallCtx = smallCv.getContext('2d', { willReadFrequently: true });
    detCv = document.createElement('canvas'); detCtx = detCv.getContext('2d');
    root.querySelector('.hwar-x').addEventListener('click', close);
    root.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('button')) return;
      var r = cv.getBoundingClientRect(); if (!r.width) return;
      tapPt = { x: (e.clientX - r.left) * cv.width / r.width, y: (e.clientY - r.top) * cv.height / r.height };
    });
    root.querySelector('.hwar-flip').addEventListener('click', function () { facing = facing === 'user' ? 'environment' : 'user'; startCamera(); });
    window.addEventListener('resize', size);
    size();

    watchImg = new Image();
    var imgP = new Promise(function (res, rej) { watchImg.onload = res; watchImg.onerror = rej; watchImg.src = o.info.url; });
    running = true;
    var tag = function (p, n) { return p.catch(function (e) { if (e && typeof e === 'object') { try { e.stage = n; } catch (x) {} } else { e = { stage: n, message: String(e) }; } throw e; }); };
    Promise.all([tag(startCamera(), 'cam'), tag(startWorker().catch(function () { return loadLandmarker(); }), 'lm'), tag(imgP, 'img'), loadThree()]).then(function (r) {
      if (!running) return;
      try { if (r[3]) setup3D(r[3]); } catch (e) { g3 = null; }
      if (!wk) { lm = r[1]; loadSegmenter(); }
      try { root.setAttribute('data-mode', wk ? 'worker' : 'main'); } catch (e) {}
      center(''); msg(T.point, T.note); loop();
    }).catch(function (e) {
      if (!running) return;
      var denied = e && (e.name === 'NotAllowedError' || e.name === 'SecurityError');
      center(denied ? T.denied : T.fail);
      var c = root && root.querySelector('.hwar-center');
      if (c && !denied) { var d = document.createElement('small'); d.style.cssText = 'display:block;margin-top:10px;font-size:11px;opacity:.55'; d.textContent = '[' + ((e && e.stage) || '?') + '] ' + String((e && (e.message || e.name)) || e).slice(0, 140) + (procInfo ? ' ' + procInfo : '') + (e && e.stack ? ' @' + String(e.stack).split('\n').slice(0, 2).join(' | ').replace(/https?:\/\/[^ ]*\//g, '').slice(0, 160) : ''); c.appendChild(d); }
      try { console.warn('HorandoWristAR', e); } catch (x) {}
    });
  }

  function startCamera() {
    if (stream) stream.getTracks().forEach(function (t) { t.stop(); });
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) return Promise.reject(new Error('nocam'));
    return navigator.mediaDevices.getUserMedia({ audio: false, video: { facingMode: { ideal: facing }, width: { ideal: 1280 }, height: { ideal: 720 } } })
      .then(function (s) {
        stream = s; video.srcObject = s; video.className = facing === 'user' ? 'mir' : ''; sm = null; F = null; raw = null; skin = null; ratioBuf = []; lastArmT = 0; lastVideoTime = -1; lockPpm = null; lockBuf = []; D = null;
        return video.play().catch(function () {});
      });
  }

  function size() {
    if (!cv) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    cv.width = Math.round(root.clientWidth * dpr); cv.height = Math.round(root.clientHeight * dpr);
    if (g3) resize3D();
  }

  function loop() {
    if (!running) return;
    raf = requestAnimationFrame(loop);
    var vw = video.videoWidth, vh = video.videoHeight;
    if (!vw || !vh) return;
    var W = cv.width, H = cv.height;
    var sc = Math.max(W / vw, H / vh), dw = vw * sc, dh = vh * sc, dx = (W - dw) / 2, dy = (H - dh) / 2;
    var mirror = facing === 'user';

    // Kamerabild zeigt das <video>-Element direkt (vom Browser fluessig dargestellt); hier nur die Uhr
    ctx.clearRect(0, 0, W, H);
    var grab = function () {
      var sw = Math.max(1, Math.round(W / SK)), sh = Math.max(1, Math.round(H / SK));
      if (smallCv.width !== sw || smallCv.height !== sh) { smallCv.width = sw; smallCv.height = sh; }
      smallCtx.save();
      if (mirror) { smallCtx.translate(sw, 0); smallCtx.scale(-1, 1); }
      smallCtx.drawImage(video, dx / SK, dy / SK, dw / SK, dh / SK);
      smallCtx.restore();
      try { smallData = smallCtx.getImageData(0, 0, sw, sh); } catch (e) { smallData = null; }
    };

    var now = performance.now();
    if (lockPpm === null && wk && video.currentTime !== lastVideoTime) {
      lastVideoTime = video.currentTime;
      grab(); maskReset();
      // schnelle Armverfolgung in jedem Bild, Hand/Arm-Erkennung kommt asynchron aus dem Worker
      if (sm && skin && raw && now - lastSeen < 2500) { if (armUpdate(now)) lastSeen = now; }
      if (tapPt) { var tp0 = tapPt; tapPt = null; if (acquire(tp0.x, tp0.y, true, W, H, now)) lastSeen = now; }
      if (!wkBusy) {
        var dsc0 = Math.min(1, 384 / Math.max(vw, vh)), dw0 = Math.round(vw * dsc0), dh0 = Math.round(vh * dsc0);
        if (detCv.width !== dw0 || detCv.height !== dh0) { detCv.width = dw0; detCv.height = dh0; }
        detCtx.drawImage(video, 0, 0, dw0, dh0);
        sendFrame(now, { dx: dx, dy: dy, dw: dw, dh: dh, mirror: mirror, W: W, H: H });
      }
    } else if (lockPpm === null && !wk && video.currentTime !== lastVideoTime) {
      lastVideoTime = video.currentTime;
      var res;
      // Erkennung auf verkleinertem Bild (ca. 384 px): deutlich schneller, v. a. auf dem iPhone
      var dsc = Math.min(1, 384 / Math.max(vw, vh)), dwid = Math.round(vw * dsc), dhei = Math.round(vh * dsc);
      if (detCv.width !== dwid || detCv.height !== dhei) { detCv.width = dwid; detCv.height = dhei; }
      detCtx.drawImage(video, 0, 0, dwid, dhei);
      // Wenn der Arm schon verfolgt wird, Handerkennung nur jedes zweite Bild (spart Rechenzeit, fluessiger)
      if (true) { try { res = lm.detectForVideo(detCv, now); } catch (e) { res = null; } } else res = null;
      if (res && res.landmarks && res.landmarks.length) {
        var L = res.landmarks[0].map(function (p) {
          var x = dx + p.x * dw, y = dy + p.y * dh;
          return { x: mirror ? W - x : x, y: y };
        });
        var label = res.handednesses && res.handednesses[0] && res.handednesses[0][0] ? res.handednesses[0][0].categoryName : 'Right';
        // Spiegeln aendert Label und Drehsinn gleichzeitig - das Produkt bleibt gleich
        var rl = res.landmarks[0];
        var cross = (rl[5].x - rl[0].x) * (rl[17].y - rl[0].y) - (rl[5].y - rl[0].y) * (rl[17].x - rl[0].x);
        var backFacing = label === 'Right' ? cross > 0 : cross < 0;
        grab(); maskReset();
        handUpdate(L, backFacing, res.worldLandmarks && res.worldLandmarks[0], mirror, now);
        lastSeen = now;
      } else if (sm && skin && raw && now - lastSeen < 2500) {
        // Hand nicht (ganz) im Bild: Unterarm ueber die gelernte Hautfarbe weiterverfolgen
        grab(); maskReset();
        if (armUpdate(now)) lastSeen = now;
        else if (segm && now - lastArmT > 500 && now - lastSegT > 600) {
          lastSegT = now;
          var Sr = runSeg(now, dx, dy, dw, dh, mirror);
          if (Sr && segAcquire(Sr, W, H, now)) lastSeen = now;
        }
        if (segm && now - lastSegT > 1500) {
          lastSegT = now;
          var Sv = runSeg(now, dx, dy, dw, dh, mirror);
          if (Sv && !segVerify(Sv, W)) { if (++segBad >= 2) { sm = null; raw = null; F = null; lastArmT = 0; segBad = 0; } } else segBad = 0;
        }
      } else if (tapPt) {
        // keine Hand erkannt: Arm direkt am angetippten Handgelenk finden
        grab();
        var tp = tapPt; tapPt = null;
        if (acquire(tp ? tp.x : W / 2, tp ? tp.y : H / 2, !!tp, W, H, now)) lastSeen = now;
      } else if (segm && now - lastSegT > 600) {
        // keine Hand: Arm automatisch ueber die Segmentierung finden
        lastSegT = now; grab();
        var Sa = runSeg(now, dx, dy, dw, dh, mirror);
        if (Sa && segAcquire(Sa, W, H, now)) lastSeen = now;
      }
    }
    // Uhr steht fest in der Bildmitte – der Kunde fuehrt sein Handgelenk darunter.
    // Die Groesse kommt aus der gemessenen Handgelenkbreite (massstabsgetreu in mm, auch fuer Damenuhren)
    // und wird nach den ersten sicheren Messungen festgehalten; danach ruht die Erkennung (fluessig).
    if (sm && lockPpm === null && now - lastArmT < 200 && lastArmT !== lockLastT) { lockLastT = lastArmT; lockBuf.push(sm.ppm); if (lockBuf.length >= 10) { lockPpm = median(lockBuf); lockBuf = []; } }
    var defPpm = Math.min(W, H) * 0.55 / body.wrist;
    var tp = lockPpm !== null ? lockPpm : (sm && now - lastArmT < 450 ? sm.ppm : (D ? D.ppm : defPpm));
    if (!D) D = { cx: W / 2, cy: H / 2, ppm: tp };
    else { D.cx = W / 2; D.cy = H / 2; D.ppm += (tp - D.ppm) * 0.15; }
    if (g3) render3D(true); else drawFlat();
    msg(lockPpm === null ? T.point : '', T.note);
    if (sm && now - lastSeen > 2500) { sm = null; F = null; raw = null; }
  }

  /* ---------- Unterarm-Tracker ----------
     Sobald die Hand einmal erkannt ist, lernt der Tracker die Hautfarbe (vom Handruecken) und misst
     danach den Unterarm selbst: Mitte, Richtung und Breite aus der Hautflaeche. Die Breite bestimmt die
     Groesse der Uhr. Ist die Hand nicht im Bild, folgt er dem Arm ueber dessen Hautstruktur weiter. */
  var skin = null, raw = null, frameN = 0, mk = null, mkW = 0, mkH = 0;
  function feat(c) { var t = c[0] + c[1] + c[2] + 1; return [c[0] / t, c[1] / t, t / 3]; }
  function fitSkin(Fs, rate) {
    var n = Fs.length, mu = 0, mv = 0, ml = 0, i, f;
    for (i = 0; i < n; i++) { f = Fs[i]; mu += f[0]; mv += f[1]; ml += f[2]; }
    mu /= n; mv /= n; ml /= n;
    var cuu = 0, cuv = 0, cvv = 0, cll = 0;
    for (i = 0; i < n; i++) { f = Fs[i]; var a = f[0] - mu, b = f[1] - mv, l = f[2] - ml; cuu += a * a; cuv += a * b; cvv += b * b; cll += l * l; }
    var nw = { mu: mu, mv: mv, ml: ml, cuu: cuu / n + 4e-4, cuv: cuv / n, cvv: cvv / n + 6e-5, cll: cll / n + 25 };
    if (!skin || rate >= 1) skin = nw;
    else for (var k in nw) skin[k] += (nw[k] - skin[k]) * rate;
    var det = skin.cuu * skin.cvv - skin.cuv * skin.cuv;
    skin.iuu = skin.cvv / det; skin.ivv = skin.cuu / det; skin.iuv = -skin.cuv / det; skin.ls = Math.sqrt(skin.cll);
  }
  function seedSkin(L, rate) {
    var a = L[0], b = L[5], c = L[17], Fs = [];
    for (var i = 0; i <= 8; i++) for (var j = 0; j <= 8 - i; j++) {
      var u = 0.15 + 0.7 * i / 8, v = 0.15 + 0.7 * j / 8; if (u + v > 0.9) continue;
      var x = a.x + (b.x - a.x) * u + (c.x - a.x) * v, y = a.y + (b.y - a.y) * u + (c.y - a.y) * v;
      var col = px(x, y); if (!col) continue;
      var f = feat(col); if (f[2] > 25 && f[2] < 248) Fs.push(f);
    }
    if (Fs.length >= 10) fitSkin(Fs, rate);
  }
  function maskReset() {
    if (!smallData) return;
    var d = smallData;
    if (!mk || mkW !== d.width || mkH !== d.height) { mkW = d.width; mkH = d.height; mk = new Uint8Array(mkW * mkH); } else mk.fill(0);
  }
  function M(gx, gy) {
    gx = Math.round(gx); gy = Math.round(gy);
    if (gx < 0 || gy < 0 || gx >= mkW || gy >= mkH) return false;
    var i = gy * mkW + gx, v = mk[i];
    if (!v) {
      var d = smallData.data, j = i * 4, t = d[j] + d[j + 1] + d[j + 2] + 1;
      var a = d[j] / t - skin.mu, b = d[j + 1] / t - skin.mv, m = a * a * skin.iuu + 2 * a * b * skin.iuv + b * b * skin.ivv;
      var lv = t / 3; v = (m < 12 && lv > skin.ml * 0.3 && lv < skin.ml * 1.35 + 15) ? 2 : 1; mk[i] = v;   // Schattenseite des Arms zulassen
    }
    return v === 2;
  }
  function lumG(gx, gy) {
    gx = Math.round(gx); gy = Math.round(gy);
    if (gx < 0 || gy < 0 || gx >= mkW || gy >= mkH) return null;
    var d = smallData.data, j = (gy * mkW + gx) * 4; return d[j] + d[j + 1] + d[j + 2];
  }
  function runLen(gx, gy, nx, ny, maxN) {
    var miss = 0, last = 0;
    for (var k = 1; k <= maxN; k++) { if (M(gx + nx * k, gy + ny * k)) { last = k; miss = 0; } else if (++miss >= 3) return last; }
    return -1;
  }
  // Arm quer zur Achse an 7 Stellen vermessen. Ergebnis in Bildschirm-px: Breite, seitlicher Versatz, Neigung
  function measureArm(cx, cy, ux, uy, wExp) {
    var g = SK, gx = cx / g, gy = cy / g, nx = -uy, ny = ux, maxN = Math.ceil(wExp / g * 1.0) + 4;
    var W = [], S = [], O = [];
    for (var i = -3; i <= 3; i++) {
      var sg = i * wExp * 0.11 / g, qx = gx + ux * sg, qy = gy + uy * sg;
      if (!M(qx, qy)) {
        var found = false, lim = Math.ceil(wExp * 0.3 / g);
        for (var o = 1; o <= lim && !found; o++) {
          if (M(qx + nx * o, qy + ny * o)) { qx += nx * o; qy += ny * o; found = true; }
          else if (M(qx - nx * o, qy - ny * o)) { qx -= nx * o; qy -= ny * o; found = true; }
        }
        if (!found) continue;
      }
      var a = runLen(qx, qy, nx, ny, maxN), b = runLen(qx, qy, -nx, -ny, maxN);
      if (a < 0 || b < 0) continue;
      var base = (qx - gx) * nx + (qy - gy) * ny;
      W.push((a + b + 1) * g); S.push(sg * g); O.push((base + (a - b) / 2) * g);
    }
    if (W.length < 4) return null;
    var w = median(W), off = median(O);
    var ms = 0, mo = 0, i2; for (i2 = 0; i2 < S.length; i2++) { ms += S[i2]; mo += O[i2]; } ms /= S.length; mo /= S.length;
    var num = 0, den = 0; for (i2 = 0; i2 < S.length; i2++) { num += (S[i2] - ms) * (O[i2] - mo); den += (S[i2] - ms) * (S[i2] - ms); }
    var slope = den > 0 ? Math.max(-0.5, Math.min(0.5, num / den)) : 0;
    return { w: w, off: off, slope: slope };
  }
  // Helligkeitsverlauf entlang der Armachse (Haare, Falten, Aermelkante) -> Verschiebung entlang des Arms
  function lumProfile(cx, cy, ux, uy, w, from, to) {
    var g = SK, nx = -uy, ny = ux, out = [];
    for (var s2 = from; s2 <= to; s2 += g) {
      var acc = 0, n = 0;
      for (var o = -w * 0.3; o <= w * 0.3; o += g) { var v = lumG((cx + ux * s2 + nx * o) / g, (cy + uy * s2 + ny * o) / g); if (v !== null) { acc += v; n++; } }
      out.push(n ? acc / n : null);
    }
    return out;
  }
  function alongShift(cx, cy, ux, uy, w) {
    if (!raw || !raw.prof) return 0;
    var R = raw.R, D = Math.round(w * 0.35 / SK), Q = lumProfile(cx, cy, ux, uy, w, -R - D * SK, R + D * SK), P = raw.prof;
    var best = 0, bestE = Infinity;
    for (var d = -D; d <= D; d++) {
      var e = 0, n = 0, mp = 0, mq = 0, k, q;
      for (k = 0; k < P.length; k++) { q = Q[k + D + d]; if (P[k] !== null && q != null) { mp += P[k]; mq += q; n++; } }
      if (n < P.length * 0.6) continue;
      mp /= n; mq /= n;
      for (k = 0; k < P.length; k++) { q = Q[k + D + d]; if (P[k] !== null && q != null) e += Math.abs((P[k] - mp) - (q - mq)); }
      e /= n; e *= 1 + Math.abs(d) * 0.01;
      if (e < bestE) { bestE = e; best = d; }
    }
    return best * SK;
  }
  function keepRaw(cx, cy, ux, uy, w) {
    var R = Math.round(w * 1.1 / SK) * SK;
    raw = { cx: cx, cy: cy, ux: ux, uy: uy, w: w, R: R, prof: lumProfile(cx, cy, ux, uy, w, -R, R) };
  }

  // Allgemeine Hautfarbe (YCbCr-Bereich) – nur fuer den Start ohne erkannte Hand
  function genericSkin(r, g, b) {
    var y = 0.299 * r + 0.587 * g + 0.114 * b, cr = 0.5 * r - 0.4187 * g - 0.0813 * b + 128, cb = -0.1687 * r - 0.3313 * g + 0.5 * b + 128;
    return y > 45 && cr > 136 && cr < 182 && cb > 78 && cb < 132;
  }
  function acquire(sx, sy, tapped, W, H, now) {
    if (!smallData) return false;
    var d = smallData.data, sw = smallData.width, sh = smallData.height, g = SK;
    var cell = function (x, y) { if (x < 0 || y < 0 || x >= sw || y >= sh) return null; var j = (y * sw + x) * 4; return [d[j], d[j + 1], d[j + 2]]; };
    var gx = Math.round(sx / g), gy = Math.round(sy / g), start = null, rr, k;
    // naechste hautfarbene Stelle um den Startpunkt suchen
    for (rr = 0; rr <= 14 && !start; rr += 2) for (k = 0; k < 16 && !start; k++) {
      var a = k / 16 * Math.PI * 2, x = Math.round(gx + Math.cos(a) * rr), y = Math.round(gy + Math.sin(a) * rr), c = cell(x, y);
      if (c && (tapped || genericSkin(c[0], c[1], c[2]))) start = [x, y];
      if (rr === 0) break;
    }
    if (!start) return false;
    var Fs = [];
    for (var j2 = -4; j2 <= 4; j2++) for (var i2 = -4; i2 <= 4; i2++) {
      var c2 = cell(start[0] + i2, start[1] + j2); if (!c2) continue;
      if ((tapped && Math.abs(i2) <= 2 && Math.abs(j2) <= 2) || genericSkin(c2[0], c2[1], c2[2])) { var f = feat(c2); if (f[2] > 25 && f[2] < 248) Fs.push(f); }
    }
    if (Fs.length < 8) return false;
    var oldSkin = skin; fitSkin(Fs, 1); maskReset();
    // Armrichtung: in 18 Richtungen messen, wie weit die Hautflaeche reicht – laengste Richtung = Arm
    var reach = function (dx, dy) {
      var miss = 0, last = 0;
      for (var k2 = 1; k2 < 400; k2++) {
        var xx = start[0] + dx * k2, yy = start[1] + dy * k2;
        if (xx < 0 || yy < 0 || xx >= mkW || yy >= mkH) return last + 2;
        if (M(xx, yy)) { last = k2; miss = 0; } else if (++miss >= 3) return last;
      }
      return last;
    };
    var best = -1, bestA = 0, lens = [];
    for (var s2 = 0; s2 < 18; s2++) {
      var an = s2 / 18 * Math.PI, cx2 = Math.cos(an), cy2 = Math.sin(an), L2 = reach(cx2, cy2) + reach(-cx2, -cy2);
      lens.push(L2); if (L2 > best) { best = L2; bestA = an; }
    }
    var perp = lens[(Math.round(bestA / Math.PI * 18) + 9) % 18];
    var ax = Math.cos(bestA), ay = Math.sin(bestA);
    if (!(perp > 3 && best / perp > 1.7)) { skin = oldSkin; return false; }
    if (ax < 0) { ax = -ax; ay = -ay; }               // Krone nach rechts, 12 Uhr nach oben (Blick des Traegers)
    var nx = -ay, ny = ax, qa = runLen(start[0], start[1], nx, ny, 200), qb = runLen(start[0], start[1], -nx, -ny, 200);
    if (qa < 0 || qb < 0) { skin = oldSkin; return false; }
    var wExp = (qa + qb + 1) * g, px0 = start[0] * g, py0 = start[1] * g;
    if (wExp < Math.min(W, H) * 0.12 || wExp > Math.min(W, H) * 0.95) { skin = oldSkin; return false; }
    var m = measureArm(px0, py0, ax, ay, wExp);
    if (!m || m.w < wExp * 0.6 || m.w > wExp * 1.6) { skin = oldSkin; return false; }
    var cx = px0 + nx * g * 0 + (-ay) * m.off, cy = py0 + ax * m.off;
    keepRaw(cx, cy, ax, ay, m.w);
    lastArmT = now; F = null; sm = null;
    applyFilters({ cx: cx, cy: cy, ux: ax, uy: ay, ppm: m.w / body.wrist, dx: 0, dy: 0, dz: 1, back: 1, side: 1, roll: 1 }, now);
    return true;
  }

  /* ---------- Arm per Segmentierung finden (ohne sichtbare Hand) ----------
     Das Segmentierungsmodell trennt Haut, Kleidung und Hintergrund. Daraus: Armachse, Breite und –
     wenn die Hand im Bild endet – das Handgelenk als schmalste Stelle vor der Hand. */
  var lastSegT = 0, segBad = 0;
  function runSeg(now, dx, dy, dw, dh, mirror) {
    if (!segm) return null;
    var r; try { r = segm.segmentForVideo(detCv, now); } catch (e) { return null; }
    var m = r && r.categoryMask; if (!m) return null;
    var S = null;
    try { S = { a: new Uint8Array(m.getAsUint8Array()), w: m.width, h: m.height, dx: dx, dy: dy, dw: dw, dh: dh, mirror: mirror }; } catch (e) {}
    try { if (r.close) r.close(); else if (m.close) m.close(); } catch (e) {}
    return S;
  }
  function segTools(S, W) {
    var a = S.a, mw = S.w, mh = S.h;
    return {
      is: function (x, y, k) { x = Math.round(x); y = Math.round(y); return x >= 0 && y >= 0 && x < mw && y < mh && a[y * mw + x] === (k || 2); },
      out: function (x, y) { return x < 0 || y < 0 || x >= mw || y >= mh; },
      toS: function (mx, my) { var x = S.dx + (mx + 0.5) / mw * S.dw; return [S.mirror ? W - x : x, S.dy + (my + 0.5) / mh * S.dh]; },
      toM: function (sx, sy) { var x = S.mirror ? W - sx : sx; return [(x - S.dx) / S.dw * mw - 0.5, (sy - S.dy) / S.dh * mh - 0.5]; }
    };
  }
  function segAcquire(S, W, H, now) {
    var T2 = segTools(S, W), mw = S.w, mh = S.h, i, x, y;
    var c = T2.toM(W / 2, H / 2), best = null, bd = Infinity, n = 0;
    for (y = 0; y < mh; y += 2) for (x = 0; x < mw; x += 2) if (T2.is(x, y)) {
      n++; var d = (x - c[0]) * (x - c[0]) + (y - c[1]) * (y - c[1]); if (d < bd) { bd = d; best = [x, y]; }
    }
    if (!best || n < mw * mh / 4 * 0.03) return false;        // zu wenig Haut im Bild
    // Hauptachse der Hautflaeche um den Punkt
    var ax = 0, ay = 0, ok = false;
    [0.22, 0.35, 0.55].some(function (fr) {
      var R = Math.round(Math.min(mw, mh) * fr), k = 0, mx = 0, my = 0, xx = 0, yy = 0, xy = 0;
      for (var yy2 = -R; yy2 <= R; yy2 += 2) for (var xx2 = -R; xx2 <= R; xx2 += 2) {
        if (xx2 * xx2 + yy2 * yy2 > R * R || !T2.is(best[0] + xx2, best[1] + yy2)) continue;
        k++; mx += xx2; my += yy2; xx += xx2 * xx2; yy += yy2 * yy2; xy += xx2 * yy2;
      }
      if (k < 20) return true;
      mx /= k; my /= k; xx = xx / k - mx * mx; yy = yy / k - my * my; xy = xy / k - mx * my;
      var tr = xx + yy, dt = Math.sqrt(Math.max(0, (xx - yy) * (xx - yy) / 4 + xy * xy)), l1 = tr / 2 + dt, l2 = tr / 2 - dt;
      if (l2 > 0 && l1 / l2 > 1.8) { var an = 0.5 * Math.atan2(2 * xy, xx - yy); ax = Math.cos(an); ay = Math.sin(an); ok = true; return true; }
      return false;
    });
    if (!ok) return false;
    var run = function (px0, py0, ddx, ddy) {
      var miss = 0, last = 0;
      for (var k2 = 1; k2 < mw + mh; k2++) { var qx = px0 + ddx * k2, qy = py0 + ddy * k2; if (T2.out(qx, qy)) return { len: last, border: true }; if (T2.is(qx, qy)) { last = k2; miss = 0; } else if (++miss >= 3) return { len: last, border: false, x: qx, y: qy }; }
      return { len: last, border: true };
    };
    var nx = -ay, ny = ax;
    var widthAt = function (px0, py0) { var r1 = run(px0, py0, nx, ny), r2 = run(px0, py0, -nx, -ny); return { w: r1.len + r2.len + 1, mx: px0 + nx * (r1.len - r2.len) / 2, my: py0 + ny * (r1.len - r2.len) / 2, edge: !r1.border && !r2.border }; };
    var w0 = widthAt(best[0], best[1]);
    if (!w0.edge) return false;
    var mid = [w0.mx, w0.my], wm = w0.w;
    // Enden des Arms entlang der Achse: ein Ende im Bild, das nicht an Kleidung grenzt = Hand
    var e1 = run(mid[0], mid[1], ax, ay), e2 = run(mid[0], mid[1], -ax, -ay);
    var clothes = function (e, sx) { if (e.border) return true; var cnt = 0; for (var k3 = 1; k3 <= 6; k3++) if (T2.is(e.x + sx * ax * k3, e.y + sx * ay * k3, 4)) cnt++; return cnt >= 2; };
    var free1 = !clothes(e1, 1), free2 = !clothes(e2, -1), pos = 0;
    if (free1 !== free2) {
      var sg = free1 ? 1 : -1, endT = free1 ? e1.len : -e2.len, bestT = null, bestW = Infinity;
      for (var t = endT - sg * wm * 0.6; sg * (t - (endT - sg * wm * 3.2)) > 0; t -= sg * 2) {
        var ww = widthAt(mid[0] + ax * t, mid[1] + ay * t); if (!ww.edge) continue;
        if (ww.w < bestW) { bestW = ww.w; bestT = t; }
      }
      if (bestT !== null) pos = bestT - sg * bestW * 0.35;     // Uhr sitzt knapp oberhalb des Handgelenks
    }
    var wq = widthAt(mid[0] + ax * pos, mid[1] + ay * pos); if (!wq.edge) wq = w0;
    var P = T2.toS(wq.mx, wq.my), P2 = T2.toS(wq.mx + ax * 10, wq.my + ay * 10);
    var ux = P2[0] - P[0], uy = P2[1] - P[1], ul = Math.hypot(ux, uy) || 1; ux /= ul; uy /= ul;
    if (ux < 0) { ux = -ux; uy = -uy; }                         // Krone nach rechts, 12 Uhr nach oben (Blick des Traegers)
    var wS = wq.w * S.dw / mw;
    if (wS < Math.min(W, H) * 0.08 || wS > Math.min(W, H) * 0.95) return false;
    // Hautfarbe fuer die schnelle Verfolgung aus der segmentierten Haut lernen
    if (!smallData) return false;
    var Fs = [], snx = -uy, sny = ux;
    for (i = -6; i <= 6; i++) for (var j = -3; j <= 3; j++) {
      var qx2 = P[0] + ux * i * wS * 0.07 + snx * j * wS * 0.09, qy2 = P[1] + uy * i * wS * 0.07 + sny * j * wS * 0.09, mm = T2.toM(qx2, qy2);
      if (!T2.is(mm[0], mm[1])) continue;
      var col = px(qx2, qy2); if (!col) continue;
      var f = feat(col); if (f[2] > 25 && f[2] < 248) Fs.push(f);
    }
    if (Fs.length < 15) return false;
    fitSkin(Fs, 1); maskReset();
    var m = measureArm(P[0], P[1], ux, uy, wS), w = wS, cx = P[0], cy = P[1];
    if (m && m.w > wS * 0.75 && m.w < wS * 1.3) { w = (m.w + wS) / 2; cx += snx * m.off * 0.5; cy += sny * m.off * 0.5; }
    keepRaw(cx, cy, ux, uy, w);
    F = null; sm = null; lastArmT = now; segBad = 0;
    applyFilters({ cx: cx, cy: cy, ux: ux, uy: uy, ppm: w / body.wrist, dx: 0, dy: 0, dz: 1, back: 1, side: 1, roll: 1 }, now);
    return true;
  }
  // Liegt die verfolgte Uhr noch auf Haut? (sonst z. B. auf den Boden "abgerutscht")
  function segVerify(S, W) {
    if (!sm) return true;
    var T2 = segTools(S, W), w = sm.ppm * body.wrist, hit = 0, tot = 0;
    for (var j = -2; j <= 2; j++) for (var i = -1; i <= 1; i++) {
      var sx = sm.cx - sm.uy * j * w * 0.15 + sm.ux * i * w * 0.2, sy = sm.cy + sm.ux * j * w * 0.15 + sm.uy * i * w * 0.2, mm = T2.toM(sx, sy);
      tot++; if (T2.is(mm[0], mm[1])) hit++;
    }
    return hit >= tot * 0.5;
  }

  function handUpdate(L, backFacing, WL, mirror, now) {
    frameN++;
    // Handflaeche/Fehlerkennung, waehrend der Arm schon verfolgt wird: am Arm bleiben
    if (!backFacing && raw && skin) { armUpdate(now); return; }
    var w0 = L[0], m9 = L[9], i5 = L[5], p17 = L[17];
    var hx = m9.x - w0.x, hy = m9.y - w0.y, hl = Math.hypot(hx, hy) || 1; hx /= hl; hy /= hl;
    var pw = Math.hypot(i5.x - p17.x, i5.y - p17.y);
    var handPpm = Math.max(pw / body.palm, hl / body.len);
    // linke oder rechte Hand: bei Handruecken zur Kamera liegt der Zeigefinger der linken Hand rechts der Achse
    var side = (hx * (i5.y - p17.y) - hy * (i5.x - p17.x)) >= 0 ? 1 : -1;
    var t = { back: backFacing ? 1 : 0, side: side, roll: 1 };
    if (backFacing && (!skin || frameN % 20 === 0)) seedSkin(L, skin ? 0.25 : 1);
    // Armachse: bisherige Achse (mit Vorzeichen zur Hand), sonst Handachse
    var ux = hx, uy = hy;
    if (raw && raw.ux * hx + raw.uy * hy > 0.5) { ux = raw.ux * 0.7 + hx * 0.3; uy = raw.uy * 0.7 + hy * 0.3; var l0 = Math.hypot(ux, uy); ux /= l0; uy /= l0; }
    var ppm0 = raw ? raw.w / body.wrist : handPpm * 1.1;
    var cx = w0.x - ux * body.offset * ppm0, cy = w0.y - uy * body.offset * ppm0;
    var m = skin && smallData ? measureArm(cx, cy, ux, uy, body.wrist * ppm0) : null;
    var ok = false;
    if (m) {
      var ppm = m.w / body.wrist, r = ppm / (raw ? ppm0 : handPpm);
      if (raw ? (r > 0.7 && r < 1.4) : (r > 0.6 && r < 2.4)) {
        ok = true;
        var nx = -uy, ny = ux;
        ux += nx * m.slope * 0.5; uy += ny * m.slope * 0.5; var l1 = Math.hypot(ux, uy); ux /= l1; uy /= l1; nx = -uy; ny = ux;
        cx = w0.x - ux * body.offset * ppm; cy = w0.y - uy * body.offset * ppm;
        var off = (cx - (w0.x - ux * body.offset * ppm0)) * nx + (cy - (w0.y - uy * body.offset * ppm0)) * ny;
        cx += nx * (m.off - off); cy += ny * (m.off - off);
        // entlang des Arms weich zur Handposition ziehen statt springen (ruhiger, wenn die Hand mal fehlt)
        if (raw) { var dAl = (cx - raw.cx) * ux + (cy - raw.cy) * uy; if (Math.abs(dAl) < m.w * 0.6) { cx -= ux * dAl * 0.5; cy -= uy * dAl * 0.5; } }
        t.ppm = ppm; lastArmT = now;
        keepRaw(cx, cy, ux, uy, m.w);
      }
    }
    if (!ok) {
      if (sm) { if (raw && skin) armUpdate(now); return; }   // Hand unsicher (z. B. Fehlerkennung): am Arm weiterverfolgen
      t.ppm = handPpm * 1.1;
    }
    t.cx = cx; t.cy = cy; t.ux = ux; t.uy = uy;
    dorsal(t, WL, mirror);
    applyFilters(t, now);
  }
  function armUpdate(now) {
    frameN++;
    var ux = raw.ux, uy = raw.uy, w = raw.w;
    var sh = alongShift(raw.cx, raw.cy, ux, uy, w);
    var cx = raw.cx + ux * sh, cy = raw.cy + uy * sh;
    var m = measureArm(cx, cy, ux, uy, w);
    if (!m) return false;
    var r = m.w / w; if (r < 0.75 || r > 1.33) return false;
    var nx = -uy, ny = ux;
    cx += nx * m.off; cy += ny * m.off;
    ux += nx * m.slope * 0.5; uy += ny * m.slope * 0.5; var l = Math.hypot(ux, uy); ux /= l; uy /= l;
    keepRaw(cx, cy, ux, uy, m.w);
    lastArmT = now;
    applyFilters({ cx: cx, cy: cy, ux: ux, uy: uy, ppm: m.w / body.wrist, dx: sm.dx, dy: sm.dy, dz: sm.dz, back: 1, side: sm.side < 0 ? -1 : 1, roll: 1 }, now);
    return true;
  }
  function applyFilters(t, now) {
    if (!F) F = newFilters();
    var n = { cx: F.cx.f(t.cx, now), cy: F.cy.f(t.cy, now), ux: F.ux.f(t.ux, now), uy: F.uy.f(t.uy, now),
      ppm: F.ppm.f(t.ppm, now), dx: F.dx.f(t.dx, now), dy: F.dy.f(t.dy, now), dz: F.dz.f(t.dz, now), back: F.back.f(t.back, now), side: F.side.f(t.side == null ? (sm ? sm.side : 1) : t.side, now), roll: t.roll };
    var l = Math.hypot(n.ux, n.uy) || 1; n.ux /= l; n.uy /= l;
    if (!sm) sm = {};
    for (var k in n) sm[k] = n[k];
  }

  /* Drehung des Handgelenks um die Armachse aus den 3D-Handpunkten (MediaPipe worldLandmarks):
     Normale der Handrueckenflaeche, senkrecht zur Armachse projiziert. Koordinaten wie three.js
     (x rechts, y oben, z zur Kamera). */
  function dorsal(t, WL, mirror) {
    t.dx = 0; t.dy = 0; t.dz = 1;
    if (!WL) return;
    var V = function (p) { return [(mirror ? -1 : 1) * p.x, -p.y, -p.z]; };
    var p0 = V(WL[0]), p5 = V(WL[5]), p17 = V(WL[17]);
    var a = [p5[0] - p0[0], p5[1] - p0[1], p5[2] - p0[2]], b = [p17[0] - p0[0], p17[1] - p0[1], p17[2] - p0[2]];
    var n = [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
    if (n[2] < 0) n = [-n[0], -n[1], -n[2]];
    var A = [t.ux, -t.uy, 0], k = n[0] * A[0] + n[1] * A[1];
    var d = [n[0] - k * A[0], n[1] - k * A[1], n[2]], l = Math.hypot(d[0], d[1], d[2]);
    if (l < 1e-6) return;
    d = [d[0] / l, d[1] / l, d[2] / l];
    // Tiefenwerte der Handpunkte sind unruhig und systematisch verkippt: Drehung stark abschwaechen (max. ca. 23 Grad)
    d = [d[0] * 0.12, d[1] * 0.12, d[2] * 0.12 + 0.88]; l = Math.hypot(d[0], d[1], d[2]); d = [d[0] / l, d[1] / l, d[2] / l];
    var minZ = 0.92;
    if (d[2] < minZ) { var q = Math.hypot(d[0], d[1]) || 1, f = Math.sqrt(1 - minZ * minZ) / q; d = [d[0] * f, d[1] * f, minZ]; }
    t.dx = d[0]; t.dy = d[1]; t.dz = d[2];
  }


  /* Unterarm im Bild vermessen: Hautfarbe kurz vor dem Handgelenk als Referenz, dann quer zum Arm
     nach beiden Seiten bis zur Kante laufen. Liefert Armmitte, Armrichtung und Handgelenkbreite -
     genauer als die Schaetzung aus der Hand, gerade wenn die Finger aus dem Bild ragen. */
  function px(x, y) {
    var d = smallData, sx = Math.round(x / SK), sy = Math.round(y / SK);
    if (sx < 0 || sy < 0 || sx >= d.width || sy >= d.height) return null;
    var i = (sy * d.width + sx) * 4; return [d.data[i], d.data[i + 1], d.data[i + 2]];
  }
  function red(x, y) {
    // Roetung r-g in Chroma-Koordinaten: Haut ~0,05-0,12, Holz/Wand/Stoff meist deutlich darunter
    var a = 0, n = 0;
    for (var j = -SK; j <= SK; j += SK) for (var i = -SK; i <= SK; i += SK) {
      var c = px(x + i, y + j); if (!c) continue;
      var t = c[0] + c[1] + c[2] + 1; a += (c[0] - c[1]) / t; n++;
    }
    return n ? a / n : null;
  }
  function edge(qx, qy, nx, ny, max) {
    var prof = [], step = SK;
    for (var s = 0; s < max; s += step) { var v = red(qx + nx * s, qy + ny * s); if (v === null) break; prof.push(v); }
    if (prof.length < 8) return -1;
    var fr = (prof[0] + prof[1] + prof[2]) / 3;
    var tail = prof.slice(Math.floor(prof.length * 0.75)).sort(function (p, q) { return p - q; });
    var fb = tail[Math.floor(tail.length / 2)];
    if (fr - fb < 0.025) return -1;
    var thr = fb + (fr - fb) * 0.45;
    for (var k = 2; k < prof.length - 2; k++) if (prof[k] < thr && prof[k + 1] < thr && prof[k + 2] < thr) return k * step;
    return -1;
  }
  function refine(t, W, H, armOnly) {
    if (!smallData) return false;
    var nx = -t.uy, ny = t.ux, ppm = t.ppm;
    var max = Math.min(Math.min(W, H) * 0.7, 150 * ppm);
    var mids = [], widths = [];
    [-10, -4, 2, 8, 14, 20].forEach(function (mm) {
      var qx = t.cx - t.ux * mm * ppm, qy = t.cy - t.uy * mm * ppm;
      var a = edge(qx, qy, nx, ny, max), b = edge(qx, qy, -nx, -ny, max);
      if (a > 0 && b > 0) { widths.push(a + b); mids.push({ x: qx + nx * (a - b) / 2, y: qy + ny * (a - b) / 2 }); }
    });
    if (widths.length < 2) return false;
    // oberer Median: eine Messung, die an einem Armband / Aermel zu frueh endet, faellt raus
    var ws = widths.slice().sort(function (p, q) { return p - q; });
    var wpx = ws[Math.floor(ws.length / 2)];
    var armPpm = wpx / body.wrist;
    var ratio = armPpm / ppm;
    if (ratio < (armOnly ? 0.75 : 0.6) || ratio > (armOnly ? 1.35 : 2.6)) return false;
    // sobald das Verhaeltnis Arm/Hand bekannt ist: Ausreisser (Fehlerkennung, Faust, Aermel) verwerfen
    if (!armOnly && ratioBuf.length >= 5) { var mr = median(ratioBuf); if (ratio < mr * 0.8 || ratio > mr * 1.25) return false; }
    var m0 = mids[0], m1 = mids[mids.length - 1];
    var ax = m0.x - m1.x, ay = m0.y - m1.y, al = Math.hypot(ax, ay);
    if (al > 4 * SK) {
      ax /= al; ay /= al;
      if (ax * t.ux + ay * t.uy > 0.8) { t.ux = t.ux * 0.3 + ax * 0.7; t.uy = t.uy * 0.3 + ay * 0.7; var l = Math.hypot(t.ux, t.uy); t.ux /= l; t.uy /= l; }
    }
    var mc = { x: (m0.x + m1.x) / 2, y: (m0.y + m1.y) / 2 };
    var off = (mc.x - t.cx) * -t.uy + (mc.y - t.cy) * t.ux;
    if (!armOnly) { var lim = wpx * 0.12; off = Math.max(-lim, Math.min(lim, off)) * 0.5; }
    t.cx += -t.uy * off; t.cy += t.ux * off;
    // Uhr sitzt mit Abstand zum Handgelenk - Abstand mit dem neuen Massstab neu setzen
    if (!armOnly) { t.cx += t.ux * body.offset * (ppm - armPpm); t.cy += t.uy * body.offset * (ppm - armPpm); }
    t.ppm = armPpm; t.arm = 1; lastArmT = performance.now();
    return true;
  }


  /* Sauberer Bandbereich des Fotos: ab wo endet das Band "gerade und voll deckend", und wie lang ist ein Glied? */
  function bandExtent(info) {
    var W = info.w, H = info.h, c = info.casePx, cy = info.caseY;
    var res = { top: 0, bot: H - 1, pTop: Math.max(2, Math.round(c * 0.2)), pBot: Math.max(2, Math.round(c * 0.2)) };
    var d;
    try { var k = document.createElement('canvas'); k.width = W; k.height = H; var kx = k.getContext('2d', { willReadFrequently: true }); kx.drawImage(watchImg, 0, 0, W, H); d = kx.getImageData(0, 0, W, H).data; } catch (e) { return res; }
    var Lo = new Int32Array(H).fill(-1), Ro = new Int32Array(H).fill(-1), cov = new Float32Array(H), lum = new Float32Array(H), y, x;
    for (y = 0; y < H; y++) {
      var l = -1, r = -1;
      for (x = 0; x < W; x++) if (d[(y * W + x) * 4 + 3] >= 200) { if (l < 0) l = x; r = x; }
      if (l < 0) continue;
      Lo[y] = l; Ro[y] = r;
      var n = 0, sum = 0, cnt = 0, a0 = l + Math.round((r - l) * 0.2), a1 = r - Math.round((r - l) * 0.2);
      for (x = l; x <= r; x++) { var i = (y * W + x) * 4; if (d[i + 3] >= 200) n++; if (x >= a0 && x <= a1) { sum += d[i] + d[i + 1] + d[i + 2]; cnt++; } }
      cov[y] = n / (r - l + 1); lum[y] = cnt ? sum / cnt / 3 : 0;
    }
    function wd(y2) { return Lo[y2] < 0 ? 0 : Ro[y2] - Lo[y2] + 1; }
    function med(arr) { arr = arr.filter(function (v) { return v > 0; }).sort(function (p, q) { return p - q; }); return arr.length ? arr[Math.floor(arr.length / 2)] : 0; }
    // Referenzbreite des Bandes direkt hinter den Hoernern
    function side(sg) {
      var a = Math.round(cy + sg * c * 0.62), b = Math.round(cy + sg * c * 0.85), ws = [];
      for (y = Math.min(a, b); y <= Math.max(a, b); y++) if (y >= 0 && y < H) ws.push(wd(y));
      var ref = med(ws), start = Math.max(0, Math.min(H - 1, Math.round(cy + sg * c * 0.62)));
      if (!ref) return { end: start, p: Math.max(2, Math.round(c * 0.2)) };
      var end = start, bad = 0;
      for (y = start; y >= 0 && y < H; y += sg) {
        var ok = wd(y) >= ref * 0.88 && wd(y) <= ref * 1.12 && cov[y] >= 0.97;
        if (ok) { end = y; bad = 0; } else if (++bad > 2) break;
      }
      end -= sg * 2;                                                 // weiche Schnittkante nicht mitnehmen
      // Zu kurzer sauberer Bereich (Band verjuengt sich, Glieder mit Luecken, Kautschuk-Profil): frueher
      // blieb dann ein 3-px-Streifen uebrig, der ums Handgelenk gekachelt senkrechte Streifen ergab.
      // Mindestens ein echtes Bandstueck von ca. 15 % des Gehaeusedurchmessers verwenden.
      var minLen = Math.max(4, Math.round(c * 0.15));
      if (sg * (end - start) + 1 < minLen) {
        var lim = start;
        for (y = start; y >= 0 && y < H && Lo[y] >= 0; y += sg) lim = y;
        lim -= sg * 2;
        end = sg * (lim - start) + 1 >= minLen ? start + sg * (minLen - 1) : lim;
        if (sg * (end - start) < 2) end = start + sg * 2;
      }
      // Glied-Laenge aus der Helligkeits-Periodik im sauberen Bereich
      var lo = Math.min(start, end), hi = Math.max(start, end), len = hi - lo + 1;
      var pMin = Math.max(3, Math.round(c * 0.06)), pMax = Math.min(Math.round(c * 0.5), Math.floor(len / 2)), best = -1, bp = 0;
      for (var p = pMin; p <= pMax; p++) {
        var sxy = 0, sxx = 0, syy = 0, mx = 0, my = 0, m = len - p;
        for (var t = lo; t < lo + m; t++) { mx += lum[t]; my += lum[t + p]; }
        mx /= m; my /= m;
        for (t = lo; t < lo + m; t++) { var u = lum[t] - mx, v = lum[t + p] - my; sxy += u * v; sxx += u * u; syy += v * v; }
        var cr = sxx > 1e-6 && syy > 1e-6 ? sxy / Math.sqrt(sxx * syy) : 0;
        if (cr > best + 0.02) { best = cr; bp = p; }
      }
      var per = best >= 0.6 ? bp : 0;
      if (!per) {
        // keine klare Glied-Periode: Abschnitt so waehlen, dass Anfang und Ende moeglichst gleich aussehen (unsichtbare Naht)
        var ref0 = sg < 0 ? lo : hi, bc = Infinity;
        for (var p2 = Math.max(pMin, Math.round(len * 0.4)); p2 <= len - 1; p2++) {
          var r2 = ref0 - sg * p2, cost = 0, nn = 0;
          for (x = 0; x < W; x += 2) { var i1 = (ref0 * W + x) * 4, i2 = (r2 * W + x) * 4; if (d[i1 + 3] < 128 && d[i2 + 3] < 128) continue; cost += Math.abs(d[i1] - d[i2]) + Math.abs(d[i1 + 1] - d[i2 + 1]) + Math.abs(d[i1 + 2] - d[i2 + 2]) + Math.abs(d[i1 + 3] - d[i2 + 3]); nn++; }
          cost /= nn || 1; if (cost < bc) { bc = cost; per = p2; }
        }
        if (!per) per = Math.min(len, Math.max(2, Math.round(c * 0.2)));
      }
      return { end: end, p: Math.max(2, Math.min(per, len)) };
    }
    var T = side(-1), B = side(1);
    res.top = T.end; res.bot = B.end; res.pTop = T.p; res.pBot = B.p;
    // Bandkanten begradigen: Glieder haben an den Seiten Kerben/Spitzen, die beim Biegen ums Handgelenk
    // zu einer Saegezahnkante werden. Im Bandbereich (ausserhalb der Hoerner) gilt daher eine gerade Kante.
    try {
      var o = new Uint8ClampedArray(d);
      [[T.end, Math.round(cy - c * 0.62)], [Math.round(cy + c * 0.62), B.end]].forEach(function (rg) {
        var a = Math.max(0, Math.min(rg[0], rg[1])), b = Math.min(H - 1, Math.max(rg[0], rg[1]));
        if (b - a < 2) return;
        var ls = [], rs = [];
        for (y = a; y <= b; y++) if (Lo[y] >= 0) { ls.push(Lo[y]); rs.push(Ro[y]); }
        var eL = med(ls.map(function (v) { return v + 1; })) - 1, eR = med(rs.map(function (v) { return v + 1; })) - 1;
        if (eR - eL < 4) return;
        // Spaltenfarbe (Mittel der deckenden Pixel) – damit gefuellte Kerben wie die Bandkante aussehen
        var cs = new Float32Array(W * 3), cn = new Float32Array(W);
        for (y = a; y <= b; y++) for (x = eL; x <= eR; x++) { var qq = (y * W + x) * 4; if (d[qq + 3] >= 250) { cs[x * 3] += d[qq]; cs[x * 3 + 1] += d[qq + 1]; cs[x * 3 + 2] += d[qq + 2]; cn[x]++; } }
        for (y = a; y <= b; y++) {
          var row = y * W, mid = Math.round((eL + eR) / 2);
          for (x = 0; x < W; x++) {
            var q = (row + x) * 4;
            if (x < eL - 1 || x > eR + 1) { o[q + 3] = 0; continue; }
            if (d[q + 3] >= 250) continue;
            // Kerbe: Farbe vom naechsten deckenden Pixel Richtung Bandmitte uebernehmen
            var xc = Math.max(eL, Math.min(eR, x)), al2 = d[q + 3] / 255;
            if (cn[xc]) { o[q] = d[q] * al2 + cs[xc * 3] / cn[xc] * (1 - al2); o[q + 1] = d[q + 1] * al2 + cs[xc * 3 + 1] / cn[xc] * (1 - al2); o[q + 2] = d[q + 2] * al2 + cs[xc * 3 + 2] / cn[xc] * (1 - al2); }
            o[q + 3] = (x === eL - 1 || x === eR + 1) ? 110 : 255;
          }
        }
      });
      var sc = document.createElement('canvas'); sc.width = W; sc.height = H;
      sc.getContext('2d').putImageData(new ImageData(o, W, H), 0, 0);
      res.src = sc;
    } catch (e) {}
    return res;
  }

  /* ---------- 3D: Uhr als Gehaeuse + Band um ein elliptisches Handgelenk ---------- */
  var g3 = null;
  function setup3D(THREE) {
    var info = opts.info, D = opts.diameter;
    var R = D / 2, h = Math.max(9, Math.min(14, D * 0.28));      // Gehaeusehoehe ueber der Haut (mm)
    var a = body.wrist / 2, b = a * 0.7;                          // Handgelenk-Querschnitt (mm)
    var Lh = D * 0.6;                                              // halbe Hoernerlaenge
    var ba = a + 1.2, bb = b + 1.2;                                // Band liegt knapp ueber der Haut

    // Querschnitt des Bandes (Y quer, Z hoch), von der 12-Uhr-Seite (+Y) ueber das Gehaeuse zur 6-Uhr-Seite
    var pts = [], i, phi;
    var phi1 = Math.acos(Math.min(0.98, (Lh + 4) / ba));
    for (i = 0; i <= 40; i++) { phi = -Math.PI / 2 + (phi1 + Math.PI / 2) * i / 40; pts.push([ba * Math.cos(phi), -b + bb * Math.sin(phi)]); }
    var e1 = pts[pts.length - 1];
    for (i = 1; i <= 8; i++) { var u = i / 8, ee = u * u * (3 - 2 * u); pts.push([e1[0] + (Lh - e1[0]) * u, e1[1] + (h * 0.55 - e1[1]) * ee]); }
    pts.push([Lh * 0.82, h]);
    for (i = 1; i <= 20; i++) pts.push([Lh * 0.82 - (Lh * 1.64) * i / 20, h]);
    pts.push([-Lh, h * 0.55]);
    var start2 = [-ba * Math.cos(phi1), -b + bb * Math.sin(phi1)];
    for (i = 1; i <= 8; i++) { var u2 = i / 8, e2 = u2 * u2 * (3 - 2 * u2); pts.push([-Lh + (start2[0] + Lh) * u2, h * 0.55 + (start2[1] - h * 0.55) * e2]); }
    for (i = 1; i <= 40; i++) { phi = Math.PI - phi1 + (phi1 + Math.PI / 2) * i / 40; pts.push([ba * Math.cos(phi), -b + bb * Math.sin(phi)]); }
    // Bogenlaenge; s0 = Gehaeusemitte (Y = 0 auf der flachen Oberseite)
    var S = [0], s0 = 0;
    for (i = 1; i < pts.length; i++) S.push(S[i - 1] + Math.hypot(pts[i][0] - pts[i - 1][0], pts[i][1] - pts[i - 1][1]));
    for (i = 1; i < pts.length; i++) if (pts[i - 1][0] >= 0 && pts[i][0] < 0 && Math.abs(pts[i][1] - h) < 0.01) { var w = pts[i - 1][0] / (pts[i - 1][0] - pts[i][0]); s0 = S[i - 1] + (S[i] - S[i - 1]) * w; break; }
    var sMin = -s0, sMax = S[S.length - 1] - s0;

    // Textur: Produktfoto, oben und unten mit dem Bandende bis um das Handgelenk verlaengert
    var pxmm = info.casePx / D;                                    // Bild-px je mm
    var k = Math.min(pxmm, 2048 / (sMax - sMin), 2048 / (info.w / pxmm));
    var sf = k / pxmm;
    var TW = Math.max(2, Math.round(info.w * sf)), TH = Math.max(2, Math.round((sMax - sMin) * k));
    var tc = document.createElement('canvas'); tc.width = TW; tc.height = TH;
    var tx = tc.getContext('2d');
    var y0 = -sMin * k - info.caseY * sf, ihS = info.h * sf;
    // Das Foto endet oben/unten meist mit einem schraeg wegknickenden, schmaler werdenden oder angeschnittenen
    // Bandstueck. Dieses Ende wird abgeschnitten; verlaengert wird mit einem sauberen, voll deckenden
    // Bandabschnitt (moeglichst genau ein Glied lang), damit keine Luecken oder Treppen entstehen.
    var ext = bandExtent(info);
    var gt = ext.top, gb = ext.bot;
    var src = ext.src || watchImg;
    tx.drawImage(src, 0, gt, info.w, gb - gt + 1, 0, y0 + gt * sf, TW, (gb - gt + 1) * sf);
    var pT = ext.pTop, pB = ext.pBot, stT = pT * sf, stB = pB * sf;
    for (var yy = y0 + gt * sf; yy > 0; yy -= stT) tx.drawImage(src, 0, gt, info.w, pT, 0, yy - stT, TW, stT + 0.5);
    for (var y2 = y0 + (gb + 1) * sf; y2 < TH; y2 += stB) tx.drawImage(src, 0, gb + 1 - pB, info.w, pB, 0, y2 - 0.5, TW, stB + 0.5);
    // Rueckseite des Bandes abdunkeln (wird dort meist verdeckt, falls nicht wirkt es natuerlicher)
    var tex = new THREE.CanvasTexture(tc);
    tex.colorSpace = THREE.SRGBColorSpace; tex.anisotropy = 4;

    // Band-Geometrie: Querschnitt entlang der Armachse (X) extrudiert
    var xL = -info.axisX / pxmm, xR = (info.w - info.axisX) / pxmm;
    var pos = [], uv = [], idx = [], col4 = [];
    for (i = 0; i < pts.length; i++) {
      var v = 1 - (S[i] * k) / TH;
      pos.push(xL, pts[i][0], pts[i][1], xR, pts[i][0], pts[i][1]);
      uv.push(0, v, 1, v);
      var ia = Math.max(0, i - 1), ib = Math.min(pts.length - 1, i + 1), ty = pts[ib][0] - pts[ia][0], tz = pts[ib][1] - pts[ia][1];
      var onArc = i <= 40 || i >= pts.length - 41;              // nur der Teil ums Handgelenk wird abgeschattet
      var nz = onArc ? Math.abs(ty) / (Math.hypot(ty, tz) || 1) : 1, sh = 0.6 + 0.4 * Math.min(1, nz / 0.6), al = Math.max(0, Math.min(1, (nz - 0.12) / 0.3));
      col4.push(sh, sh, sh, al, sh, sh, sh, al);
      if (i) { var q = (i - 1) * 2; idx.push(q, q + 2, q + 1, q + 1, q + 2, q + 3); }
    }
    var geo = new THREE.BufferGeometry();
    geo.setAttribute('position', new THREE.Float32BufferAttribute(pos, 3));
    geo.setAttribute('uv', new THREE.Float32BufferAttribute(uv, 2));
    geo.setAttribute('color', new THREE.Float32BufferAttribute(col4, 4));
    geo.setIndex(idx); geo.computeVertexNormals();
    var band = new THREE.Mesh(geo, new THREE.MeshLambertMaterial({ map: tex, vertexColors: true, transparent: true, alphaTest: 0.04, side: THREE.DoubleSide }));
    band.renderOrder = 2;

    // Gehaeuseflanke in der Farbe des Gehaeuserands
    var col = ringColor(info);
    var wall = new THREE.Mesh(new THREE.CylinderGeometry(R * 0.97, R * 0.9, h, 64, 1, true),
      new THREE.MeshLambertMaterial({ color: new THREE.Color().setRGB(col[0] / 255, col[1] / 255, col[2] / 255, THREE.SRGBColorSpace), side: THREE.DoubleSide }));
    wall.rotation.x = Math.PI / 2; wall.position.z = h / 2 - 0.2; wall.renderOrder = 1;
    // Die Uhr steht immer exakt waagerecht von oben – die Flanke ist dann nie zu sehen, schaute aber
    // ueberall dort als dunkler Ring hervor, wo das Gehaeuse im Foto nicht kreisrund ist. Daher aus.
    wall.visible = false;

    // unsichtbares Handgelenk: verdeckt den Teil des Bandes hinter dem Arm
    var occ = new THREE.Mesh(new THREE.CylinderGeometry(1, 1, 400, 48, 1, false),
      new THREE.MeshBasicMaterial({ colorWrite: false }));
    // Zylinder-Achse (lokal Y) per Drehung um Z auf die Armachse X; lokal X wird quer (Y), lokal Z bleibt Tiefe
    occ.rotation.z = Math.PI / 2; occ.scale.set(a * 0.99, 1, b * 0.99); occ.position.z = -b; occ.renderOrder = 0;

    var group = new THREE.Group();
    group.add(occ); group.add(wall); group.add(band);

    var scene = new THREE.Scene();
    scene.add(new THREE.AmbientLight(0xffffff, 1.9));
    var dl = new THREE.DirectionalLight(0xffffff, 1.3); dl.position.set(-0.3, 0.7, 1); scene.add(dl);
    scene.add(group);

    var glc = document.createElement('canvas'); glc.className = 'hwar-gl';
    cv.insertAdjacentElement('afterend', glc);
    var renderer = new THREE.WebGLRenderer({ canvas: glc, alpha: true, antialias: true, premultipliedAlpha: true });
    renderer.setPixelRatio(1);
    renderer.setClearColor(0x000000, 0);
    var camera = new THREE.OrthographicCamera(0, 1, 0, -1, -10000, 10000);
    camera.position.z = 5000;
    g3 = { THREE: THREE, renderer: renderer, scene: scene, camera: camera, group: group, R: R, h: h, b: b, glc: glc };
    resize3D();
  }
  function resize3D() {
    var W = cv.width, H = cv.height;
    g3.renderer.setSize(W, H, false);
    g3.camera.left = 0; g3.camera.right = W; g3.camera.top = 0; g3.camera.bottom = -H; g3.camera.updateProjectionMatrix();
  }
  function ringColor(info) {
    try {
      var c = document.createElement('canvas'); c.width = info.w; c.height = info.h;
      var x = c.getContext('2d'); x.drawImage(watchImg, 0, 0);
      var r = info.casePx / 2 * 0.985, acc = [0, 0, 0], n = 0;
      for (var i = 0; i < 72; i++) {
        var an = i / 72 * Math.PI * 2, d = x.getImageData(Math.round(info.axisX + Math.cos(an) * r), Math.round(info.caseY + Math.sin(an) * r), 1, 1).data;
        if (d[3] > 200) { acc[0] += d[0]; acc[1] += d[1]; acc[2] += d[2]; n++; }
      }
      if (n) return [acc[0] / n * 0.85, acc[1] / n * 0.85, acc[2] / n * 0.85];
    } catch (e) {}
    return [150, 150, 150];
  }
  function render3D(show) {
    var G = g3, THREE = G.THREE;
    G.group.visible = !!(show && D);
    if (G.group.visible) {
      // Uhr gerade halten: liegt der Arm annaehernd waagerecht (bis ca. 30 Grad), steht die Uhr exakt
      // waagerecht (Krone rechts, 12 Uhr oben). Nur bei deutlich schraegem/senkrechtem Arm folgt sie dem Arm.
      // Keine Kippung nach vorn/hinten.
      // Vorgabe: Uhr IMMER exakt waagerecht (Krone rechts, 12 Uhr oben), unabhaengig von der Armlage
      var X = new THREE.Vector3(1, 0, 0);
      var Z = new THREE.Vector3(0, 0, 1);
      Z.addScaledVector(X, -Z.dot(X)).normalize();
      var Y = new THREE.Vector3().crossVectors(Z, X).normalize();
      var m = new THREE.Matrix4().makeBasis(X, Y, Z);
      G.group.quaternion.setFromRotationMatrix(m);
      G.group.scale.setScalar(D.ppm);
      // Armachse liegt in der Bildebene unter der Armmitte; die Uhr sitzt um b darueber
      var O = new THREE.Vector3(D.cx, -D.cy, 0).addScaledVector(Z, G.b * D.ppm);
      G.group.position.copy(O);
      // weicher Schatten auf der Haut
      var top = new THREE.Vector3(0, 0, G.h).applyMatrix4(G.group.matrixWorld.compose(G.group.position, G.group.quaternion, G.group.scale));
      // Schatten als Verlauf (ctx.filter/blur gibt es in Safari nicht -> sonst harte dunkle Scheibe)
      var sx = top.x + G.R * D.ppm * 0.1, sy = -top.y + G.R * D.ppm * 0.15, sr = G.R * D.ppm * 1.3;
      var gr = ctx.createRadialGradient(sx, sy, sr * 0.55, sx, sy, sr);
      gr.addColorStop(0, 'rgba(0,0,0,0.28)'); gr.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.save(); ctx.fillStyle = gr; ctx.beginPath(); ctx.arc(sx, sy, sr, 0, Math.PI * 2); ctx.fill(); ctx.restore();
    }
    G.renderer.render(G.scene, G.camera);
  }

  /* Uhr als freigestelltes Produktfoto, flach und massstabsgetreu (Gehaeusedurchmesser in mm).
     Kein 3D-Band, keine verlaengerten Bandstuecke: so sieht sie exakt aus wie auf dem Produktbild.
     Die Bandenden laufen weich aus, damit am Arm keine harte Kante entsteht. */
  var flatC = null;
  function flatImage() {
    if (flatC) return flatC;
    var info = opts.info, c = document.createElement('canvas'); c.width = info.w; c.height = info.h;
    var x = c.getContext('2d'); x.drawImage(watchImg, 0, 0, info.w, info.h);
    var top = info.caseY - info.casePx * 0.5, bot = info.caseY + info.casePx * 0.5;
    var g = x.createLinearGradient(0, 0, 0, info.h);
    var f1 = Math.max(0, top - info.casePx * 0.55) / info.h, f2 = Math.max(0, top - info.casePx * 0.15) / info.h;
    var f3 = Math.min(info.h, bot + info.casePx * 0.15) / info.h, f4 = Math.min(info.h, bot + info.casePx * 0.55) / info.h;
    g.addColorStop(0, 'rgba(0,0,0,0)'); g.addColorStop(Math.min(f1, f2), 'rgba(0,0,0,0)'); g.addColorStop(f2, 'rgba(0,0,0,1)');
    g.addColorStop(f3, 'rgba(0,0,0,1)'); g.addColorStop(Math.max(f3, f4), 'rgba(0,0,0,0)'); g.addColorStop(1, 'rgba(0,0,0,0)');
    x.globalCompositeOperation = 'destination-in'; x.fillStyle = g; x.fillRect(0, 0, info.w, info.h);
    flatC = c; return c;
  }
  function drawFlat() {
    if (!D || !opts || !opts.info) return;
    var info = opts.info, img = flatImage();
    var s2 = D.ppm * opts.diameter / info.casePx;        // Bild-px -> Bildschirm-px
    var w = info.w * s2, h = info.h * s2;
    ctx.save();
    ctx.shadowColor = 'rgba(0,0,0,0.35)'; ctx.shadowBlur = Math.max(4, D.ppm * 2.5); ctx.shadowOffsetY = D.ppm * 1.2;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(img, D.cx - info.axisX * s2, D.cy - info.caseY * s2, w, h);
    ctx.restore();
  }
  function draw() {
    if (!D) return;
    var info = opts.info;
    var s = D.ppm * opts.diameter / info.casePx;           // Bild-px -> Bildschirm-px
    var iw = Math.max(1, Math.round(info.w * s)), ih = Math.max(1, Math.round(info.h * s));
    var half = body.wrist / 2 * D.ppm * 1.08;
    var caseY = info.caseY * s;
    // Produktfotos zeigen das Band nur ein Stueck weit: oben und unten mit dem Bandende verlaengern
    var extT = Math.max(0, Math.ceil(half - caseY)), extB = Math.max(0, Math.ceil(half - (ih - caseY)));
    var oh = ih + extT + extB;
    if (off.width !== iw || off.height !== oh) { off.width = iw; off.height = oh; }
    offCtx.globalCompositeOperation = 'source-over';
    offCtx.clearRect(0, 0, iw, oh);
    offCtx.drawImage(watchImg, 0, extT, iw, ih);
    var strip = Math.max(2, Math.round(info.h * 0.1)), stripD = strip * s;
    for (var y = extT; y > 0; y -= stripD) offCtx.drawImage(watchImg, 0, 0, info.w, strip, 0, y - stripD, iw, stripD);
    for (var y2 = extT + ih; y2 < oh; y2 += stripD) offCtx.drawImage(watchImg, 0, info.h - strip, info.w, strip, 0, y2, iw, stripD);
    // Band laeuft ums Handgelenk: zum Rand hin ausblenden und abdunkeln
    var cyImg = caseY + extT;
    var g = offCtx.createLinearGradient(0, cyImg - half, 0, cyImg + half);
    g.addColorStop(0, 'rgba(0,0,0,0)'); g.addColorStop(0.08, 'rgba(0,0,0,1)'); g.addColorStop(0.92, 'rgba(0,0,0,1)'); g.addColorStop(1, 'rgba(0,0,0,0)');
    offCtx.globalCompositeOperation = 'destination-in'; offCtx.fillStyle = g; offCtx.fillRect(0, 0, iw, oh);
    var d = offCtx.createLinearGradient(0, cyImg - half, 0, cyImg + half);
    d.addColorStop(0, 'rgba(0,0,0,.6)'); d.addColorStop(0.25, 'rgba(0,0,0,0)'); d.addColorStop(0.75, 'rgba(0,0,0,0)'); d.addColorStop(1, 'rgba(0,0,0,.6)');
    offCtx.globalCompositeOperation = 'source-atop'; offCtx.fillStyle = d; offCtx.fillRect(0, 0, iw, oh);
    offCtx.globalCompositeOperation = 'source-over';

    ctx.save();
    ctx.translate(D.cx, D.cy);
    // Uhr immer gerade (waagerecht)
    ctx.shadowColor = 'rgba(0,0,0,.45)'; ctx.shadowBlur = 10 * D.ppm / 4; ctx.shadowOffsetY = 2 * D.ppm / 4;
    ctx.drawImage(off, -info.axisX * s, -cyImg);
    ctx.restore();
  }

  function onKey(e) { if (e.key === 'Escape') close(); }
  function close() {
    running = false;
    cancelAnimationFrame(raf);
    if (stream) stream.getTracks().forEach(function (t) { t.stop(); });
    stream = null; sm = null;
    if (g3) { try { g3.renderer.dispose(); } catch (e) {} g3 = null; }
    if (wk) { try { wk.terminate(); } catch (e) {} wk = null; wkBusy = false; wkSegReady = false; wkGeom = {}; }
    if (root) root.remove(); root = null;
    window.removeEventListener('resize', size);
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }


  /* ---------- Einbindung in die Ansicht "Am Handgelenk" ----------
     Eigenstaendig: Dieses Skript wird vom Snippet horando-wrist-tryon geladen und setzt den Knopf
     "Live mit Kamera" selbst in das Fenster von horando-wrist-tryon.js ein. Freistellung und
     Gehaeusemessung des Produktfotos erfolgen hier mit derselben Methode wie dort. */
  function parseDiameter(v) {
    if (!v) return null;
    var m = String(v).replace(',', '.').match(/(\d+(?:\.\d+)?)/);
    if (!m) return null;
    var d = parseFloat(m[1]);
    return d >= 15 && d <= 60 ? d : null;
  }
  function el(tag, attrs, html) {
    var e = document.createElement(tag);
    if (attrs) for (var k in attrs) e.setAttribute(k, attrs[k]);
    if (html != null) e.innerHTML = html;
    return e;
  }

  /* ---------- Bildanalyse: freistellen + Gehäusebreite messen ---------- */
  var cache = {};
  function analyse(src) {
    if (cache[src]) return cache[src];
    cache[src] = new Promise(function (resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        try { resolve(process(img)); } catch (e) { reject(e); }
      };
      img.onerror = reject;
      img.src = src;
    });
    return cache[src];
  }

  /* Löcher und schmale Schlitze in der Uhren-Silhouette schließen.
     Morphologisches Schließen der Maske (Radius ~1 % der Bildbreite), danach werden
     alle durchsichtigen Pixel im Inneren deckend gemacht und mit den Farben der
     angrenzenden Uhrenpixel aufgefüllt – so scheint nirgends Haut durch die Uhr. */
  function morph(src, W, H, r, dilate) {
    var tmp = new Uint8Array(W * H), out = new Uint8Array(W * H), x, y, k, v;
    for (y = 0; y < H; y++) {
      for (x = 0; x < W; x++) {
        v = dilate ? 0 : 1;
        for (k = -r; k <= r; k++) {
          var xx = x + k;
          var s = (xx < 0 || xx >= W) ? (dilate ? 0 : 0) : src[y * W + xx];
          if (dilate ? s : !s) { v = dilate ? 1 : 0; break; }
        }
        tmp[y * W + x] = v;
      }
    }
    for (x = 0; x < W; x++) {
      for (y = 0; y < H; y++) {
        v = dilate ? 0 : 1;
        for (k = -r; k <= r; k++) {
          var yy = y + k;
          var s2 = (yy < 0 || yy >= H) ? 0 : tmp[yy * W + x];
          if (dilate ? s2 : !s2) { v = dilate ? 1 : 0; break; }
        }
        out[y * W + x] = v;
      }
    }
    return out;
  }
  function closeHoles(d, bg, W, H) {
    var n = W * H, fg = new Uint8Array(n), i;
    for (i = 0; i < n; i++) fg[i] = bg[i] ? 0 : 1;
    var r = Math.max(3, Math.round(W * 0.011));
    var closed = morph(morph(fg, W, H, r, true), W, H, r, false);
    for (i = 0; i < n; i++) if (fg[i]) closed[i] = 1;

    // Zeilenweise zwischen den Außenkanten auffüllen. Rechts sitzt die Krone,
    // deshalb wird die linke Kante an der Mittelachse gespiegelt.
    var Lr = new Int32Array(H).fill(-1), Rr = new Int32Array(H).fill(-1), y, x0, top = -1, bot = -1;
    for (y = 0; y < H; y++) {
      for (x0 = 0; x0 < W; x0++) if (closed[y * W + x0]) { Lr[y] = x0; break; }
      if (Lr[y] < 0) continue;
      for (x0 = W - 1; x0 >= 0; x0--) if (closed[y * W + x0]) { Rr[y] = x0; break; }
      if (top < 0) top = y; bot = y;
    }
    if (top >= 0) {
      var hh = bot - top + 1, mids = [];
      for (y = top + Math.round(hh * 0.03); y < top + Math.round(hh * 0.16); y++) if (Lr[y] >= 0) mids.push((Lr[y] + Rr[y]) / 2);
      for (y = bot - Math.round(hh * 0.16); y < bot - Math.round(hh * 0.03); y++) if (Lr[y] >= 0) mids.push((Lr[y] + Rr[y]) / 2);
      mids.sort(function (a, b) { return a - b; });
      var ax = mids.length ? mids[Math.floor(mids.length / 2)] : W / 2;
      for (y = top; y <= bot; y++) {
        if (Lr[y] < 0) continue;
        var xe = Math.min(Rr[y], Math.round(2 * ax - Lr[y]));
        for (x0 = Lr[y]; x0 <= xe; x0++) closed[y * W + x0] = 1;
      }
    }
    var inner = morph(closed, W, H, 1, false);       // äußerster Rand bleibt weich
    // aufzufüllende Pixel: innen, aber nicht voll deckend
    var need = new Uint8Array(n), queue = [], known = new Uint8Array(n);
    for (i = 0; i < n; i++) {
      if (inner[i] && d[i * 4 + 3] < 250) need[i] = 1;
      else if (d[i * 4 + 3] >= 250) known[i] = 1;
    }
    // Farbe aus Nachbarn ausbreiten (Ringweise von außen nach innen)
    var fill = new Float32Array(n * 3), frontier = [], queued = new Uint8Array(n);
    for (i = 0; i < n; i++) {
      if (!need[i]) continue;
      var x = i % W;
      if ((x > 0 && known[i - 1]) || (x < W - 1 && known[i + 1]) || (i >= W && known[i - W]) || (i < n - W && known[i + W])) { frontier.push(i); queued[i] = 1; }
    }
    var guard = 0;
    while (frontier.length && guard++ < 4000) {
      var next = [], done = [];
      for (var f = 0; f < frontier.length; f++) {
        var p = frontier[f]; if (known[p]) continue;
        var px = p % W, sr = 0, sg = 0, sb = 0, c = 0;
        for (var dy = -1; dy <= 1; dy++) for (var dx = -1; dx <= 1; dx++) {
          var qx = px + dx, q = p + dy * W + dx;
          if (qx < 0 || qx >= W || q < 0 || q >= n || !known[q]) continue;
          if (need[q]) { sr += fill[q * 3]; sg += fill[q * 3 + 1]; sb += fill[q * 3 + 2]; }
          else { sr += d[q * 4]; sg += d[q * 4 + 1]; sb += d[q * 4 + 2]; }
          c++;
        }
        if (!c) continue;
        fill[p * 3] = sr / c; fill[p * 3 + 1] = sg / c; fill[p * 3 + 2] = sb / c;
        done.push(p);
      }
      for (var j = 0; j < done.length; j++) known[done[j]] = 1;
      for (j = 0; j < done.length; j++) {
        var o = done[j], ox = o % W;
        var nbs = [ox > 0 ? o - 1 : -1, ox < W - 1 ? o + 1 : -1, o - W, o + W];
        for (var m = 0; m < 4; m++) { var t = nbs[m]; if (t >= 0 && t < n && need[t] && !known[t] && !queued[t]) { queued[t] = 1; next.push(t); } }
      }
      frontier = next;
    }
    // Pixel deckend machen, vorhandene Halbtransparenz über die Füllfarbe legen
    for (i = 0; i < n; i++) {
      if (!need[i]) continue;
      var a = d[i * 4 + 3] / 255;
      d[i * 4] = Math.round(d[i * 4] * a + fill[i * 3] * (1 - a));
      d[i * 4 + 1] = Math.round(d[i * 4 + 1] * a + fill[i * 3 + 1] * (1 - a));
      d[i * 4 + 2] = Math.round(d[i * 4 + 2] * a + fill[i * 3 + 2] * (1 - a));
      d[i * 4 + 3] = 255;
      bg[i] = 0;
    }
  }

  function process(img) {
    var maxW = 700, sc = Math.min(1, maxW / img.naturalWidth);
    var W = Math.round(img.naturalWidth * sc), H = Math.round(img.naturalHeight * sc);
    var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
    var cx = cv.getContext('2d', { willReadFrequently: true });
    cx.drawImage(img, 0, 0, W, H);
    var id = cx.getImageData(0, 0, W, H), d = id.data, n = W * H;

    // Hintergrund: transparent vorhanden? sonst Flood-Fill auf Weiß vom Rand aus
    var transparent = d[3] < 20 && d[(W - 1) * 4 + 3] < 20 && d[(n - 1) * 4 + 3] < 20;
    var bg = new Uint8Array(n);
    if (transparent) {
      // nur Transparenz, die mit dem Bildrand verbunden ist, ist Hintergrund –
      // eingeschlossene Löcher (z. B. zwischen den Bandanstößen) gehören zur Uhr
      var st = [];
      for (var tx = 0; tx < W; tx++) { st.push(tx, (H - 1) * W + tx); }
      for (var ty = 0; ty < H; ty++) { st.push(ty * W, ty * W + W - 1); }
      while (st.length) {
        var tp = st.pop();
        if (bg[tp] || d[tp * 4 + 3] >= 128) continue;
        bg[tp] = 1;
        var tpx = tp % W;
        if (tpx > 0) st.push(tp - 1);
        if (tpx < W - 1) st.push(tp + 1);
        if (tp >= W) st.push(tp - W);
        if (tp < n - W) st.push(tp + W);
      }
    } else {
      // Hintergrundton am Bildrand messen (meist reines Weiss 254/255) und nur Pixel sehr nahe daran
      // als Hintergrund werten – helles Stahl-Armband (ca. 225-249) bleibt so erhalten
      var bv = [];
      for (var bx = 0; bx < W; bx += 4) { bv.push(Math.min(d[bx * 4], d[bx * 4 + 1], d[bx * 4 + 2])); var bq = ((H - 1) * W + bx) * 4; bv.push(Math.min(d[bq], d[bq + 1], d[bq + 2])); }
      for (var by = 0; by < H; by += 4) { var bl = by * W * 4, br = (by * W + W - 1) * 4; bv.push(Math.min(d[bl], d[bl + 1], d[bl + 2]), Math.min(d[br], d[br + 1], d[br + 2])); }
      bv.sort(function (p, q) { return p - q; });
      var bgLev = bv[Math.floor(bv.length * 0.7)];
      var thr = Math.max(200, bgLev - 4);
      var isW = function (p) {
        var r = d[p * 4], g = d[p * 4 + 1], b = d[p * 4 + 2];
        var mn = Math.min(r, g, b), mx = Math.max(r, g, b);
        return mn >= thr && mx - mn < 10;
      };
      var stack = [];
      for (var x = 0; x < W; x++) { stack.push(x, (H - 1) * W + x); }
      for (var y = 0; y < H; y++) { stack.push(y * W, y * W + W - 1); }
      while (stack.length) {
        var p = stack.pop();
        if (bg[p] || !isW(p)) continue;
        bg[p] = 1;
        var px = p % W;
        if (px > 0) stack.push(p - 1);
        if (px < W - 1) stack.push(p + 1);
        if (p >= W) stack.push(p - W);
        if (p < n - W) stack.push(p + W);
      }
      // weiche Kante: Randpixel nahe Weiß teiltransparent
      for (var q = 0; q < n; q++) {
        if (bg[q]) { d[q * 4 + 3] = 0; continue; }
        var qx = q % W;
        var nb = (qx > 0 && bg[q - 1]) || (qx < W - 1 && bg[q + 1]) || (q >= W && bg[q - W]) || (q < n - W && bg[q + W]);
        if (nb) {
          var m2 = Math.min(d[q * 4], d[q * 4 + 1], d[q * 4 + 2]);
          d[q * 4 + 3] = Math.max(60, Math.min(255, Math.round((255 - m2) * 6)));
        }
      }
      cx.putImageData(id, 0, 0);
    }

    closeHoles(d, bg, W, H);
    cx.putImageData(id, 0, 0);

    // Zeilenweise linke/rechte Kante
    var L = new Int32Array(H).fill(-1), R = new Int32Array(H).fill(-1);
    var top = -1, bot = -1, minX = W, maxX = 0;
    for (var yy = 0; yy < H; yy++) {
      var row = yy * W, l = -1, r = -1;
      for (var xx = 0; xx < W; xx++) if (!bg[row + xx]) { l = xx; break; }
      if (l < 0) continue;
      for (var xr = W - 1; xr >= 0; xr--) if (!bg[row + xr]) { r = xr; break; }
      L[yy] = l; R[yy] = r;
      if (top < 0) top = yy; bot = yy;
      if (l < minX) minX = l; if (r > maxX) maxX = r;
    }
    if (top < 0) throw new Error('leer');
    var h = bot - top + 1;

    // Mittelachse aus den Bandbereichen oben/unten (ohne Krone)
    var mids = [];
    function band(a, b) { for (var yb = a; yb < b; yb++) if (L[yb] >= 0) mids.push((L[yb] + R[yb]) / 2); }
    band(top + Math.round(h * 0.03), top + Math.round(h * 0.16));
    band(bot - Math.round(h * 0.16), bot - Math.round(h * 0.03));
    mids.sort(function (a, b) { return a - b; });
    var axis = mids.length ? mids[Math.floor(mids.length / 2)] : (minX + maxX) / 2;

    // Gehäuse = größte halbe Breite; je Zeile zählt die schmalere Seite, weil Krone,
    // Drücker und Heliumventil nur einseitig vorstehen (gleiche Methode wie horando-wrist-tryon.js).
    // Vorher zählte nur die linke Seite: beim Heliumventil links (z. B. Seamaster) lag das Gehäuse
    // dann zu hoch und zu groß -> Uhr zu klein, Band falsch zugeschnitten, Streifen im Band.
    var halfs = [];
    for (var yh = top; yh <= bot; yh++) if (L[yh] >= 0) halfs.push({ y: yh, v: Math.min(axis - L[yh], R[yh] - axis) });
    var sorted = halfs.map(function (o) { return o.v; }).sort(function (a, b) { return b - a; });
    var half = sorted[Math.min(sorted.length - 1, Math.round(sorted.length * 0.01))];
    var ys = halfs.filter(function (o) { return o.v >= half * 0.97; }).map(function (o) { return o.y; });
    var caseCy = ys.reduce(function (s, v) { return s + v; }, 0) / ys.length;

    // Ausschnitt
    var pad = 4, ox = Math.max(0, minX - pad), oy = Math.max(0, top - pad);
    var cw = Math.min(W, maxX + pad) - ox, ch = Math.min(H, bot + pad) - oy;
    var out = document.createElement('canvas'); out.width = cw; out.height = ch;
    out.getContext('2d').drawImage(cv, ox, oy, cw, ch, 0, 0, cw, ch);
    return {
      url: out.toDataURL('image/png'),
      w: cw, h: ch,
      casePx: half * 2,
      axisX: axis - ox,
      caseY: caseCy - oy
    };
  }


  function pageData() {
    var n = document.getElementById('horando-tryon-data'); if (!n) return null;
    try { return JSON.parse(n.textContent); } catch (e) { return null; }
  }
  function canLive() { return !!(window.isSecureContext && navigator.mediaDevices && navigator.mediaDevices.getUserMedia); }
  function trackEv(name, d) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('horando_' + name, { diameter: d }); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'horando_' + name, diameter: d }); } catch (e) {}
  }
  function startLive() {
    var d = pageData(); if (!d || root) return;
    var dia = parseDiameter(d.diameter); if (!dia) return;
    var female = !!(d.gender && /dam|lad(y|ies)|women|femme|donna|señora|femin|női|жен|жін/i.test(d.gender) && !/unisex|unissex|унисекс|унісекс/i.test(d.gender));
    if (document.querySelector('.hti-ov [data-g="1"].on')) female = true;
    if (document.querySelector('.hti-ov [data-g="0"].on')) female = false;
    trackEv('tryon_camera', dia);
    analyse(d.image).then(function (inf) { open({ info: inf, diameter: dia, female: female, title: d.title }); });
  }
  function injectBtn() {
    var ctl = document.querySelector('.hti-ov .hti-ctl');
    if (!ctl || ctl.querySelector('.hwar-live, .hti-live') || !canLive()) return;
    if (!document.getElementById('hwar-btn-css')) {
      var st = document.createElement('style'); st.id = 'hwar-btn-css';
      st.textContent = '.hwar-live{display:flex;align-items:center;gap:12px;width:100%;padding:12px 14px;border:1px solid #141414;background:#141414;color:#fff;border-radius:2px;cursor:pointer;text-align:left;min-height:0}.hwar-live:hover{background:#333}.hwar-live svg{width:22px;height:22px;flex:0 0 auto}.hwar-live b{display:block;font-family:"DM Sans",sans-serif;font-size:13px;font-weight:500;letter-spacing:.08em;text-transform:uppercase}.hwar-live small{display:block;font-family:"IBM Plex Sans",sans-serif;font-size:12px;opacity:.8;margin-top:2px}';
      document.head.appendChild(st);
    }
    var b = document.createElement('button'); b.type = 'button'; b.className = 'hwar-live';
    b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 8h3l2-3h6l2 3h3v11H4z"/><circle cx="12" cy="13" r="3.5"/></svg><span><b>' + T.btn + '</b><small>' + T.btnSub + '</small></span>';
    b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); startLive(); });
    ctl.insertBefore(b, ctl.firstChild);
  }
  // Escape schliesst nur die Kamera-Ansicht, nicht zusaetzlich das Fenster darunter
  window.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root) { e.stopPropagation(); close(); } }, true);
  if (pageData()) {
    new MutationObserver(function () { injectBtn(); }).observe(document.body, { childList: true });
    injectBtn();
  }

  window.HorandoWristAR = { open: open, close: close, state: function () { return sm; }, mode: function () { return wk ? 'worker' : 'main'; }, cutout: function (src) { return analyse(src); } };
})();

